import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import { useNavigate } from "react-router-dom";
import redirectURL from "../redirectURL";
import DatePicker from "react-datepicker";
import 'react-datepicker/dist/react-datepicker.css';
import SweetAlert from "react-bootstrap-sweetalert";
import "../../assets/css/fontawesome.css";
import SuccessTick from "../../assets/icons/success_tick.png";



function addConsignment() {

    const navigate = useNavigate();

    const handleBack = () => {
        navigate('/consignments/active_consignments')
    }
    const decipher = salt => {
        const textToChars = text => text.split('').map(c => c.charCodeAt(0));
        const applySaltToChar = code => textToChars(salt).reduce((a, b) => a ^ b, code);
        return encoded => encoded.match(/.{1,2}/g)
            .map(hex => parseInt(hex, 16))
            .map(applySaltToChar)
            .map(charCode => String.fromCharCode(charCode))
            .join('');
    }
    const decode = decipher("Z744cRBHYjQTsI6cOlNaUKbuEQF6MiEr")
    var localStorageEmail = localStorage.getItem("email")


    const [consignmentCount, setConsignmentCount] = useState(2)
    const [invoicePrevValue, setInvoicePrevValue] = useState("")
    const [showCards, setShowCards] = useState([true, true])
    const [formData, setFormData] = useState({
        lr_no: "",
        courier_partner: { label: "", value: "" },
        fuel_type: { label: "", value: "" },
        driver_mobile_no: "",
        dispatch_time: new Date(),
        movement_type: { label: "", value: "" },
        source: { label: "", value: "" },
        invoice_no: "",
        invoice_date: "",
        consigner_name: "",
        truck_no: "",
        truck_seal_no: "",
        entity: {label:"", value:""},
        vehicle_type: { label: '', value: '' },
        other_vehicle_type: "",
        other_vehicle_capacity: "",
        consignee_code: {label:"", value:""},
        consignee_name: "",
        consignee_name1: {label:"", value:""},
        other_consignee_name: "",
        vehicle_capacity: "",
        number_of_boxes: "",
        invoice_category:"",
        destination_city: "",
        other_destination_city: "",
        destination_pincode: "",
        other_destination_pincode: "",
        eway_bill_expiry_date: "",
        total_weight: "",
        total_cbm: "",
        fuel_type: { label: "", value: "" },
        other_source: "",
        other_source_pincode: "",
        invoice_no_str: "",
        input_consignee_code:"",
        delivery_date_time : new Date(),
    })
    const [otherConsignments, setOtherConsignments] = useState([]);
    const [fuelTypeList, setFuelTypeList] = useState([
        { label: "Diesel", value: "Diesel" },
        { label: "EV", value: "EV" },
        { label: "CNG", value: "CNG" },
        { label: "Rail", value: "Rail" },
        { label: "Air", value: "Air" },
        { label: "Sea", value: "Sea" },
    ]);

    var [vehicleTypeList, setVehicleTypeList] = useState([]);
    var [vehicleFtlTypeList, setVehicleFtlTypeList] = useState([]);
    var [vehiclePtlTypeList, setVehiclePtlTypeList] = useState([]);
    var [courierPartnerList, setCourierPartnerList] = useState([]);
    var [vehicleFtlTypeArr1, setVehicleFtlArr1] = useState([]);
    var [courierPartnerList1, setCourierPartnerList1] = useState([]);
    const [originalSourceList, setOriginalSourceList] = useState([]);
    const [sourceList, setSourceList] = useState([]);
    const [supplierMovementSourceList, setSupplierMovementSourceList] = useState([]);
    const [seriesRecords, setSeriesRecords] = useState([]);
    const [sourceSeriesList, setSourceSeriesList] = useState([]);
    const [consignees, setConsignees] = useState([])
    const [consigneeNameNCodes, setConsigneeNameNCode] = useState([])
    const [consigneeCodesList, setConsigneeCodesList] = useState([])
    const [invoiceNos, setInvoiceNos] = useState([]);
    const [mobileNumber, setMobileNumber] = useState('');
    const [enableEdit, setEnableEdit] = useState(true);
    const [movementType, setMovementType] = useState([
        { label: "Internal Movement", value: "Internal Movement" },
        { label: "Customer Delivery", value: "Customer Delivery" },
        { label: "Customer Returns", value: "Customer Returns" },
        { label: "Supplier Movement", value: "Supplier Movement" }
    ])
    const [supplierList, setSupplierList] = useState([
        { label: "Sambe Electronics Pvt.Ltd.", value: "Sambe Electronics Pvt.Ltd." },
        { label: "Nirmiti Precision Pvt.Ltd.", value: "Nirmiti Precision Pvt.Ltd." },
        { label: "Bhavnish Metal India Pvt. Ltd", value: "Bhavnish Metal India Pvt. Ltd" },
        { label: "Crescent Electronics Pvt. Ltd", value: "Crescent Electronics Pvt. Ltd" },
        { label: "Elegant Coatings Pvt.Ltd.", value: "Elegant Coatings Pvt.Ltd." },
        { label: "Penguin Electronics", value: "Penguin Electronics" },
        { label: "Spectrum Polytech", value: "Spectrum Polytech" },
        { label: "SG Control & Switchgear", value: "SG Control & Switchgear" },
        { label: "Thriam Moulds & Dies Pvt. Ltd.", value: "Thriam Moulds & Dies Pvt. Ltd." },
        { label: "Sw metaform", value: "Sw metaform" },
        { label: "Birla Cable", value: "Birla Cable" },
        { label: "Anmol Polymer", value: "Anmol Polymer" },
        { label: "Master Components Limitted", value: "Master Components Limitted" },
        { label: "SCR Electronics", value: "SCR Electronics" },
        { label: "Elmeasure", value: "Elmeasure" },
        { label: "WALTER PACK AUTOMOTIVE PRODUCTS PVT LTD", value: "WALTER PACK AUTOMOTIVE PRODUCTS PVT LTD" },
        { label: "Nasik metal Dust Pvt ltd", value: "Nasik metal Dust Pvt ltd" },
        { label: "Atul Met Fab", value: "Atul Met Fab" },
        { label: "Elin Electronics", value: "Elin Electronics" },
        { label: "Billtech Electricals", value: "Billtech Electricals" },
        { label: "Verizon", value: "Verizon" },
        { label: "Novateur Electrical & Digital Systems Pvt Ltd", value: "Novateur Electrical & Digital Systems Pvt Ltd" },
    ])
    const [sourceValidation, setSourceValidation] = useState(false);
    const [enableSourceField, setEnableSourceField] = useState(false)
    const [validOtherSource, setValidOtherSource] = useState(null)
    const [sourceList1, setSourceList1] = useState([]);
    const [errorMsg1, setErrorMsg1] = useState(false);
    const [isValid, setIsValid] = useState(true);
    const [validateTruckNo, setValidTruckNo] = useState(true);
    let [SIMTrackingTpts, setSimTrackingTpts] = useState([]);
    const [invoiceValid, setInvoiceValid] = useState(false);
    const [pincodeErrInBasic, setPincodeErrInBasic] = useState(false);
    const [pincodeErrInConsignment, setPincodeErrInConsignment] = useState([]);
    const [invoiceValidForInvoiceLevel, setInvoiceValidForInvoiceLevel] = useState(false);
    const [entityList, setEntityList] = useState([
        { label: "Adlec", value: "Adlec" },
        { label: "Indoasian", value: "Indoasian" },
        { label: "Legrand", value: "Legrand" },
        { label: "Numeric", value: "Numeric" },
        { label: "Valrack", value: "Valrack" },
        { label: "Netrack", value: "Netrack" },
    ]);
    const [enableVehicleType, setEnableVehicelType] = useState(false)
    const [validCity, setValidCity] = useState(true);
    const [validCity1, setValidCity1] = useState(true);
    const [validPincode, setValidPincode] = useState(null);
    const [validPincodeForCons, setValidPincodeForCons] = useState([]);
    const [validVehicleCapacity, setValidVehicleCapacity] = useState(null)
    var [tptNFuel, settptNFuel] = useState([]);
    const [manualTripUploadDetails, setManualTripUploadDetails] = useState([
        // {
        //   id: uuidv4(),
        //   lr_no: '',
        //   consignee_name: "",
        //   invoice_no: "",
        //   no_of_boxes: "",
        //   destination_pincode: "",
        //   destination_city: "",
        //   eway_bill_no: "",
        //   customer_mail_id: "",
        // }
    ]);
    const [ enableConsignee, setEnableConsigee] = useState(false);
    const [loadshow, setLoadShow] = useState("show-n")
    const [overlay, setOverlay] = useState("show-n")
    const [show, setShow] = useState(false)
    const [title, setTitle] = useState('')
    const [type, setType] = useState('default')
    var [saveConfirmationSlide, setSaveConfirmationSlide] = useState("");
    const [isTripsDelivered, setIsTripsDelivered] = useState(0);
    const [tabName, setTabName] = useState("onTrip");
    const [pincodeTouched, setPincodeTouched] = useState(false);




    const isDuplicateLR = (currentValue, currentIndex = -1) => {
        // Log to check if currentIndex is excluded properly
        const lowerCaseCurrentValue = currentValue.toLowerCase();
    
        // Collect all LR Nos from other consignments except the current one
        const allLRNos = [
            ...(formData.lr_no ? [formData.lr_no.toLowerCase()] : []),  // Include formData.lr_no if it exists (as a single value)
            ...otherConsignments
                .filter((_, idx) => idx !== currentIndex)  // Exclude the current consignment index
                .map(c => c.lr_no.toLowerCase())  // Map to get only the lr_no values
        ];
    
        // Log the result of the allLRNos array to debug the exclusion
        
        // Check if the currentValue exists in allLRNos or if formData.lr_no is the same as currentValue
        return allLRNos.includes(lowerCaseCurrentValue) 
    };
    
    
    
    const isDuplicateInvoice = (value, currentIndex = -1) => {
        // Split and clean the input invoice string into an array
        const newInvoices = value
            .split(',')
            .map((item) => item.trim())
            .filter(Boolean)  // Remove empty entries
            .map((invoice) => invoice.toLowerCase());  // Convert all invoices to lowercase for case-insensitive comparison
    
        // Collect all invoices except the current one and convert to lowercase
        const allInvoices = [
            // If formData.invoice_no exists, convert each invoice_no to lowercase and add to allInvoices
            ...(currentIndex !== 0 ? formData.invoice_no?.map(invoice => invoice.toLowerCase()) : []),
            // Process otherConsignments and convert each invoice_no to lowercase
            ...otherConsignments.flatMap((c, idx) =>
                idx !== currentIndex - 1 
                  ? (c.invoice_no ? 
                      Array.isArray(c.invoice_no) 
                        ? c.invoice_no.map(invoice => invoice.toLowerCase())  // If it's an array, map and convert to lowercase
                        : [c.invoice_no.toLowerCase()] // If it's a single value, convert directly
                      : []
                    ) 
                  : []  // Exclude the current consignment
              )
        ];
    
    
        // Check if any invoice in the new input exists in allInvoices (case-insensitive)
        return newInvoices.some(invoice => allInvoices.includes(invoice));
    };
    
    
    

    const handleInputChange = (e) => {
        
        const { name, value } = e.target
        // const alphanumericRegex = /^[a-zA-Z0-9]*$/;
        const alphanumericRegex = /^[^\s]*$/


        if (name === 'lr_no') {
            /* PMS ID - 10259 */
            if (!alphanumericRegex.test(value)) {
              return; // prevent updating state if value is not alphanumeric 
            }

            // if (isDuplicateLR(value, 0)) {
            //     alert('LR No must be unique across all consignments');
            //     return;
            //   }
          }
        if(name==="other_source_pincode"){
            const isValid = /^[0-9]{0,6}$/.test(value);
            if (isValid) {
              setFormData(prev => ({
                ...prev,
                other_source_pincode: value
              }));
            }
        }else{
            setFormData(prev => ({
                ...prev,
                [name]: value
            }))
        }
        
        if (name === "other_source") {
            validateOtherSource(value); // Trigger validation for 'other_source' if applicable
        }
    }
    const handleLRNoBlur = (e, index) => {
        const { value, name  } = e.target;
        
        if (isDuplicateLR(value, index)) {
            alert('LR No must be unique across all consignments');
            setOtherConsignments((prev) => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    [name]: "",
                };
                return updated;
            });
        }
    }; 
    const handleEwayDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        setFormData(prev => ({ ...prev, eway_bill_expiry_date: date }));
    };

    const validateOtherSource = (source) => {
        const regex = /^[a-zA-Z]+$/;  // Only letters allowed
        const isValid = regex.test(source);
        setValidOtherSource(isValid);
    };
    const handleConsignment = (index) => {
        setShowCards(prev => {
            const updated = [...prev];
            updated[index] = !updated[index]
            return updated;
        })
    }

    const handleDelConsignment = (index) => {
        // Remove the (index - 1)th consignment from otherConsignments
        setOtherConsignments(prev => {
            const updated = [...prev];
            updated.splice(index - 1, 1); // since index 0 is formData
            return updated;
        });
    
        // Remove the index-th showCard from showCards
        setShowCards(prev => {
            const updated = { ...prev };
            delete updated[index];
            return updated;
        });
    
        // Decrease consignment count
        setConsignmentCount(prev => prev - 1);

    };
    const fetchingSourceSeries = (source) => {
        const validSeries = sourceSeriesList.filter(e=> e.label===source).map(e=>e.value)
        setValidSourceSeries(validSeries)
    };

    const handleArrow = (index) => {
        setShowCards((prev) => ({
            ...prev,
            [index]: !prev[index],
          }));
      };
      
    
    const handleToggle = () => {
        setIsTripsDelivered(prev => (prev === 1 ? 0 : 1));
    };

    const handleTabChange = (tab) => {
        setTabName(tab);
        if (tab === "onTrip") {
            setIsTripsDelivered(0);
        } else if (tab === "offTrip") {
            setIsTripsDelivered(1);
        }
    };

    const [invoiceTypeList, setInvoiceTypeList] = useState([]);
    const [loadingInvoiceTypes, setLoadingInvoiceTypes] = useState(false);

    const fetchInvoiceTypes = async () => {
        try {
            setLoadingInvoiceTypes(true);

            const response = await redirectURL.post("/getInvoiceDetails");
            console.log("Full invoice response:", response.data);

            const dataArray = Array.isArray(response.data.records)
                ? response.data.records
                : [];

            const uniqueCategories = [
                ...new Set(
                    dataArray
                        .map((item) => item?.invoice_category)
                        .filter(Boolean)
                        .map((v) => v.trim())
                ),
            ];

            const formattedOptions = uniqueCategories.map((e) => ({
                label: e,
                value: e,
            }));

            console.log("Formatted InvoiceTypeList:", formattedOptions);
            setInvoiceTypeList(formattedOptions);
        } catch (error) {
            console.error("Error fetching invoice types:", error);
            setInvoiceTypeList([]);
        } finally {
            setLoadingInvoiceTypes(false);
        }
    };
    useEffect(() => {
        if (!pincodeTouched) return;

        const pincode = formData.destination_pincode;

        if (/^[0-9]{6}$/.test(pincode)) {
            setPincodeErrInBasic(false);
        } else {
            setPincodeErrInBasic(true);
        }
    }, [formData.destination_pincode, pincodeTouched]);


    useEffect(() => {
        fetchInvoiceTypes();
    }, []);

    useEffect(() => {
        redirectURL.post('/consignments/getVehicleMaster')
            .then(resp => {
                var records = resp.data.vehicleMaster
                var ftlVehicleArr = records.filter((e) => e.tracking_type === "FTL");
                var ptlVehicleArr = records.filter((e) => e.tracking_type === "PTL");


                var vehicleFtlArr = ftlVehicleArr.map((e) => e.vehicle_type);
                var vehiclePtlArr = ptlVehicleArr.map((e) => e.vehicle_type);
                var vehicleArr = records.map((e) => e.vehicle_type);
                var vehicleCapacityArr = records.map((e) => e.vehicle_capacity);
                var vehicleTypeList = []
                var vehicleCapacityList = []
                var vehicleTypeFtlList = []
                var vehicleTypePtlList = []
                var vehicleTypeFtlArr = []
                for (let i of vehicleFtlArr) {
                    vehicleTypeFtlList.push({ label: i, value: i })
                    vehicleTypeFtlArr.push(i.toLowerCase())
                }
                for (let i of vehiclePtlArr) {
                    vehicleTypePtlList.push({ label: i, value: i })
                }
                for (let i of vehicleArr) {
                    vehicleTypeList.push({ label: i, value: i })
                }
                for (let i of vehicleCapacityArr) {
                    vehicleCapacityList.push({ label: i, value: i })
                }


                // vehicleTypeList.push({label:"Other", value:"Other"});
                vehicleCapacityList.push({ label: "Others", value: "Others" });
                vehicleTypeList.push({ label: "Others", value: "Others" });
                vehicleTypeFtlList.push({ label: "Others", value: "Others" });
                vehicleTypePtlList.push({ label: "Others", value: "Others" });
                setVehicleTypeList(vehicleTypeList)
                setVehicleFtlTypeList(vehicleTypeFtlList)
                setVehiclePtlTypeList(vehicleTypePtlList)
                setVehicleFtlArr1(vehicleTypeFtlArr)

            })
        redirectURL.post('/consignments/getTransportersList')
            .then(resp => {
                var records = resp.data.tptMaster;
                var simTrackingtps = records.filter((e) => e.transporter_type === "FTL" && e.tracking_type === "Sim Tracking").map((e) => e.transporter_name.toLowerCase());
                // console.log(simTrackingtps, "simTrackingTpts99");

                setSimTrackingTpts(simTrackingtps);
                var tptNames = records.filter((e) => e.transporter_type == "FTL" || e.transporter_type === "FTL/PTL").map((e) => e.transporter_name);

                var tptNamesList = []
                for (let i of tptNames) {
                    tptNamesList.push({ label: capitalizeWords(i), value: i })
                }
                var tptNFueltypes = records.map(e => ({ label: e.transporter_name.toLowerCase(), value: e.fuel_type }))
                settptNFuel(tptNFueltypes)


                var tptNames1 = records
                    .filter(e => e.transporter_name && e.transporter_name !== "") // Filter records with valid transporter_name
                    .map(e => e.transporter_name); // Extract only transporter_name

                var tptNamesList1 = []
                for (let i of tptNames1) {
                    tptNamesList1.push({ label: i, value: i })
                }
                // tptNamesList.push({label:"Others", value:"Others"});
                setCourierPartnerList(tptNamesList)
                setCourierPartnerList1(tptNamesList1)
            })
        redirectURL.post("/consignments/getSourceTypes")
            .then(resp => {
                let records = resp.data.sourceMaster;
                let sourceList = []
                let sourceSeries = []

                let sourceSet = new Set();
                let seriesSet = new Set();
                for (let i of records) {
                    if (i.invoice_source !== "Nan") {
                        if (!sourceSet.has(i.invoice_source)) {
                            sourceList.push({ label: capitalizeWords(i.invoice_source), value: i.invoice_source })
                            sourceSet.add(i.invoice_source)
                        }
                        if (!seriesSet.has(i.invoice_series)) {
                            seriesSet.add(i.invoice_series)
                        }
                        sourceSeries.push({ label: i.invoice_source, value:i.invoice_series })

                    }
                }

                var arr1 = Array.from(sourceSet)
                var arr2 = Array.from(seriesSet)
                sourceList.push({ label: "Others", value: "Others" })

                setOriginalSourceList(sourceList)

                setSourceList(sourceList)
                setSeriesRecords(arr2);
                setSourceSeriesList(sourceSeries)
                // setCourierPartnerList(tptNamesList)
            })
        redirectURL.post("/consignments/getConsigners")
            .then(resp => {
                let records = resp.data.consignerMaster;

                // var sources = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);
                let consignerList = []
                let consignerSet = new Set();
                for (let i of records) {
                    if (i.consigner_code && i.consigner_name) {
                        if (!consignerSet.has(i.consigner_code)) {
                            //console.log(i.consignee_name, "9990000");

                            consignerList.push({ label: capitalizeWords(i.consigner_name), value: i.consigner_code })
                            consignerSet.add(i.consigner_code)
                        }
                    }
                }
                consignerList.push({ label: "Others", value: "Others" })
                //console.log(consigneeList, "consigneeList556");


                setConsignees(consignerList)
            })
            redirectURL.post("/consignments/getConsigneeNameNCode")
            .then(resp => {
                let records = resp.data.consigneeMaster;

                // var sources = records.filter((e)=> e.transporter_type == "FTL").map((e)=> e.transporter_name);
                let consigneeList = []
                let consigneeCodesList =[]
                let consigneeCodeSet = new Set();
                for (let i of records) {
                    if (i.consignee_code && i.consignee_name) {
                        if (!consigneeCodeSet.has(i.consignee_code)) {
                            //console.log(i.consignee_name, "9990000");

                            consigneeList.push({ 
                                label: `${i.consignee_code}- ${capitalizeWords(i.consignee_name)}`, 
                                value: i.consignee_name })
                            consigneeCodesList.push({
                                label: i.consignee_code , value: i.consignee_code
                            })
                            consigneeCodeSet.add(i.consignee_code)
                        }
                    }
                }
                consigneeList.push({ label: "Others", value: "Others" })
                //console.log(consigneeList, "consigneeList556");

                setConsigneeCodesList(consigneeCodesList)
                setConsigneeNameNCode(consigneeList)

            })


    }, [])

    useEffect(() => {
        redirectURL.post("/consignments/getSupplierMovementSources")
            .then(resp => {
                let records = resp.data.supplierSourceMaster || [];
                let supplierSourceList = []
                let supplierSourceSet = new Set();
                for (let i of records) {
                    if (i.invoice_source && !supplierSourceSet.has(i.invoice_source)) {
                        supplierSourceList.push({ label: capitalizeWords(i.invoice_source), value: i.invoice_source })
                        supplierSourceSet.add(i.invoice_source)
                    }
                }
                setSupplierMovementSourceList(supplierSourceList)
            })
    }, [])
    const fetchingMaxFuelType = async (tptName) => {

        await redirectURL.post("/consignments/getMaxFuelType").then((response) => {
            if (response.data.status === "success") {
                let tptNfuelData = response.data.result;

                let validMaxFuelType = tptNfuelData[tptName.toUpperCase()]


                setFormData((prev) => ({
                    ...prev,
                    fuel_type: { label: validMaxFuelType, value: validMaxFuelType }
                }))
            }
        })
    }
    const handlePhoneInputChange = (e) => {
        const { name, value } = e.target;
        var isValidStart = /^[6-9][0-9]*$/;
        if (value !== "" && isValidStart.test(value) && value.length <= 10) {
            setMobileNumber(value);
        } else if (value === "") {
            setMobileNumber("");
        }
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleInvoiceChange = (e, name, index = null) => {
        const value = e.target.value;
        
       
          setInvoiceValidForInvoiceLevel(false)
       


        const invoiceArray = value.split(',').map((item) => item.trim()).filter(Boolean);
        if (name === "truckLevel") {
            setOtherConsignments(prev =>
                prev.map(item => ({
                  ...item,
                  invoice_no: [],
                  invoice_no_str: ""
                }))
              );
            // if (isDuplicateInvoice(value, 0)) {
            //     alert('Invoice No must be unique across all consignments');
            //     return;
            //   }
            setFormData(prev => ({ ...prev, invoice_no_str: value, invoice_no: invoiceArray }));
        } else if (name === "invoiceLevel" && index !== null) {
            // if (isDuplicateInvoice(value, index + 1)) {
            //     alert('Invoice No must be unique across all consignments');
            //     return;
            //   }
            setOtherConsignments(prev => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    invoice_no_str: value,
                    invoice_no: invoiceArray
                };
                return updated;
            })
        }
        // if (invoiceArray.length > 0 && /[\/]/.test(invoiceArray[0])) {
        //     filterSources(invoiceArray);  // Call filterSources if the value contains a slash
        // } 
        // const isValid = validateInput(invoiceArray);
        // setIsValid(isValid);  
    };
    const validateInput = (input, name) => {
        

        if (input === "" || input === null || input === undefined) {
            setSourceList1(originalSourceList);
            return true;
        }

        const validateInvoice = (invoice) => {
            const regex = /^[A-Za-z0-9]+(\/[A-Za-z0-9]+)?$/;
            return regex.test(invoice);
        };
        // Ensure all invoices are unique
        for (let i of input) {
            const lowerCase = i.toLowerCase();
            if (invoiceNos.includes(lowerCase)) {
                setShow(true);
                setTitle("Please select unique invoice no");
                setType("danger");
                return;
            }
            if (!validateInvoice(lowerCase)) {

                setShow(true);
                setTitle("All invoice's should be valid");
                setType("danger");
                return;
            }
        }

        let noSeries = true;
        for (let invoice of input) {
            if (invoice.includes("/")) {
                noSeries = false;
                break;
            }
        }

        if (noSeries) {
            setSourceList1(originalSourceList);
            if (name === "truckLevel") {
                setInvoiceValid(false);
            } else {
                setInvoiceValidForInvoiceLevel(false)
            }
            return true;
        }

        if (input.length >= 1) {
            let finalSource = new Set();
            let finalSeries = new Set();

            // Function to validate invoice format

            for (let i = 0; i < input.length; i++) {
                const currentInvoice = input[i];
                if (currentInvoice.includes("/")) {
                    const currentSeries = currentInvoice.split("/")[1];
                    
                    var isSeriesValid=seriesRecords.includes(currentSeries.toUpperCase())
                    if(!isSeriesValid){
                        setShow(true);
                        setTitle("Please enter valid series");
                        setType("danger");
                        setInvoiceValid(false);
                        return;
                    }
                    const seriesList = sourceSeriesList.find(
                        (e) => e.value.toLowerCase() === currentSeries.toLowerCase()
                    );
                    
    
                    if (seriesList) {
                        finalSource.add(seriesList.label);
                        finalSeries.add(seriesList.value)
                    }
                }
            }
            const firstItem = [...finalSource][0]

            const selectedSourceSeries1 = sourceSeriesList.filter(e=> e.label===firstItem).map(e=>e.value);
            

            let selectedSeries = Array.from(finalSeries)
            

            let isValidSeries= selectedSeries.every(item=> selectedSourceSeries1.includes(item))
            
            

            if (finalSource.size === 1 || isValidSeries) {
                const [value] = finalSource;
                let filteredSource = originalSourceList.filter((e) => e.value === value);
                filteredSource.push({ label: "Others", value: "Others" });
    
                setSourceList1(filteredSource);
                setFormData((prev) => ({
                    ...prev,
                    source: { label: filteredSource[0].label, value: filteredSource[0].value }
                }));
                setInvoiceValid(false);

                return true;
            }
        }
    }
    const validateInputForInvoice = (input, name, index, e) => {
        const value = e.target.value
            if (isDuplicateInvoice(value, index+1)) {
                alert('Invoice No must be unique across all consignments');
                setOtherConsignments(prev => {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        invoice_no_str: "",
                        invoice_no: ""
                    };
                    return updated;
                })
                return true;
              }
            
        
        let selectedSource = formData.source.value;
        let validSeries = sourceSeriesList.filter(e=> e.label===selectedSource).map(e=>e.value)

        if (input === "" || input === null || input === undefined) {
            setSourceList1(originalSourceList);
            return true;
        }

        const validateInvoice = (invoice) => {
            const regex = /^[A-Za-z0-9]+(\/[A-Za-z0-9]+)?$/;
            return regex.test(invoice);
        };
        // Ensure all invoices are unique
        for (let i of input) {
            const lowerCase = i.toLowerCase();
            if (invoiceNos.includes(lowerCase)) {
                setShow(true);
                setTitle("Please select unique invoice no");
                setType("danger");
                return;
            }
            if (!validateInvoice(lowerCase)) {

                setShow(true);
                setTitle("All invoice's should be valid");
                setType("danger");
                return;
            }
        }

        let noSeries = true;
        for (let invoice of input) {
            if (invoice.includes("/")) {
                noSeries = false;
                break;
            }
        }

        if (noSeries) {
            if (name === "truckLevel") {
                setInvoiceValid(false);
            } else {
                setInvoiceValidForInvoiceLevel(false)
            }
            return true;
        }

        if (input.length >= 1) {
            let finalSource = new Set();

            // Function to validate invoice format


            for (let i = 0; i < input.length; i++) {
                const currentInvoice = input[i];



                if (currentInvoice.includes("/")) {
                    const currentSeries = currentInvoice.split("/")[1];


                    
                    var isSeriesValid=validSeries.includes(currentSeries.toUpperCase())
                    if(!isSeriesValid){
                        setShow(true);
                        setTitle("Please enter valid series");
                        setType("danger");
                        setInvoiceValidForInvoiceLevel(false);
                        return;
                    }
                    const seriesList = sourceSeriesList.find(
                        (e) => e.value.toLowerCase() === currentSeries.toLowerCase()
                    );
    
                    if (seriesList) {
                        finalSource.add(seriesList.label);
                    }
                }
            }

            if (finalSource.size === 1) {
                
    
               
                setInvoiceValidForInvoiceLevel(false);

                return true;
            }
        }
    }
    const handleTruckNoChange = (e) => {
        const { name, value } = e.target
        const value1 = value.toUpperCase().replace(/\s+/g, "");
        if (name == "truck_no") {
            setFormData(prev => ({ ...prev, truck_no: value1 }));
        }

        validateTruckNoFun(value1);
    };
    const validateTruckNoFun = (value) => {
        // Define the regex for the truck number format SN12TR2345
        const regex = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,10}$/;        // Check if the input matches the regex pattern
        const isValid = regex.test(value);

        setValidTruckNo(isValid);
    };
    const fetchVehicleDetails = (x, y) => {
        let data = {
            vehicle_type: y,
        }
        redirectURL.post('/consignments/fetchVehicleDetails', data).then((resp) => {
            setFormData(prev => ({ ...prev, vehicle_capacity: resp.data.vehicleDetails[0].vehicle_capacity }))
        })
    }
    const fetchConsignerDetails = (x, y, name, index = null) => {
        let data = {
            consigner_name: x,
            consigner_code: x
        };

        redirectURL.post('/consignments/fetchConsignerDetails', data).then((resp) => {
            const details = resp.data.consignerDetails?.[0];

            if (name === "truckLevel") {
                // setFormData((prev) => ({
                //     ...prev,
                //     destination_pincode: details?.consigner_pincode || "",
                //     destination_city: details?.consigner_city || ""
                // }));
                const newPincode = details?.consigner_pincode || "";

                setFormData((prev) => ({
                    ...prev,
                    destination_pincode: newPincode,
                    destination_city: details?.consigner_city || ""
                }));
            } else if (name === "invoiceLevel" && index !== null) {
                setOtherConsignments((prev) => {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        destination_pincode: details?.consigner_pincode || "",
                        destination_city: details?.consigner_city || ""
                    };
                    return updated;
                });
            }
        });
    };
    const fetchConsigneeDetails = (x, y, name, index = null) => {
        let data = {
            consignee_name: x,
        };

        redirectURL.post('/consignments/fetchConsigneeMasterDetails', data).then((resp) => {
            const details = resp.data.consigneeDetails?.[0];

            if (name === "truckLevel") {
                setFormData((prev) => ({
                    ...prev,
                    consignee_code:  {label:details?.consignee_code , value: details?.consignee_code}  || "",
                }));
            } else if (name === "invoiceLevel" && index !== null) {
                setOtherConsignments((prev) => {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        consignee_code:  {label:details?.consignee_code , value: details?.consignee_code}  || "",
                    };
                    return updated;
                });
            }
        });
    };
    const fetchConsigneeCodeDetails = (x, y, name, index = null) => {
        let data = {
            consignee_code: x,
        };

        redirectURL.post('/consignments/fetchConsigneeCodeMasterDetails', data).then((resp) => {
            const details = resp.data.consigneeDetails?.[0];

            if (name === "truckLevel") {
                setFormData((prev) => ({
                    ...prev,
                    consignee_name1: {label:details?.consignee_name , value: details?.consignee_name} || "",
                }));
            } else if (name === "invoiceLevel" && index !== null) {
                setOtherConsignments((prev) => {
                    const updated = [...prev];
                    updated[index] = {
                        ...updated[index],
                        consignee_name1:  {label:details?.consignee_name , value: details?.consignee_name}  || "",
                    };
                    return updated;
                });
            }
        });
    };

    const enableOtherField = (e) => {
        if (e === "vehicleType") {
            if (formData.vehicle_type.value === "Others") {
                setEnableVehicelType(true)
            } else {
                setFormData(prev => ({ ...prev, other_vehicle_type: "", other_vehicle_capacity: "" }))
                setEnableVehicelType(false)
            }
        }
        else if (e === "transporter") {
            if (formData.courier_partner.value === "Others") {
                setEnableCourierType(true)
            } else {
                setFormData(prev => ({ ...prev, other_transporter: "" }))
                setEnableCourierType(false)
            }
        }
        // else if(e === "vehicleCapacity"){
        //     if(formData.vehicle_capacity.value === "Others"){
        //         setEnableVehicleCapacity(true)
        //     } else {
        //         setFormData(prev =>({...prev, other_vehicle_capacity:""}))
        //         setEnableVehicleCapacity(false)
        //     }
        // } 
        else if (e === "consigneeName") {
            if (formData.consignee_name.value === "Others") {
                setEnableConsigee(true)
            } else {
                setFormData(prev => ({ ...prev, other_consignee_name: "" }))
                setEnableConsigee(false)
                // let droppointconsigneelist = consignees.filter(e => e.value !== formData.consignee_name.value)
                // setDropPointConsignee(droppointconsigneelist)
            }
        }
    }
    const validateOption = (fieldType) => {
        switch (fieldType) {
            case "vehicleType":
                enableOtherField("vehicleType");
                break;
            case "transporter":
                enableOtherField("transporter");
                break;
            case "vehicleCapacity":
                enableOtherField("vehicleCapacity");
                break;
            case "consigneeName":
                enableOtherField("consigneeName");
                break;
            case "dropConsigneeName":
                enableOtherField("dropConsigneeName");
                break;
            default:
                break;

        }
    }
    const validateOption1 = (fieldType, index) => {
        switch (fieldType) {
            case "vehicleType":
                enableOtherField1("vehicleType", index);
                break;
            case "transporter":
                enableOtherField1("transporter", index);
                break;
            case "vehicleCapacity":
                enableOtherField1("vehicleCapacity", index);
                break;
            case "consigneeName":
                enableOtherField1("consigneeName", index);
                break;
            case "dropConsigneeName":
                enableOtherField1("dropConsigneeName", index);
                break;
            default:
                break;

        }
    }
    const enableOtherField1 = (e, index) => {

        if (e === "consigneeName") {
            const updated = [...otherConsignments];
            updated[index]["other_consignee_name"] = "";
            setOtherConsignments(updated);

            // let droppointconsigneelist = consignees.filter(e => e.value !== formData.consignee_name.value)
            // setDropPointConsignee(droppointconsigneelist)
        }
    }
    const checkOtherConsigneeName = (fieldName, value) => {
        const pincodeRegex = /^[0-9]{6}$/;
        const cityRegex = /^[a-zA-Z\s]+$/;

        if (fieldName === "other_destination_city") {
            const isValid = cityRegex.test(value.trim());
            setValidCity(isValid);
        } else if (fieldName === "other_destination_pincode") {
            const isValid = pincodeRegex.test(value.trim());
            setValidPincode(!isValid);
        }
    };
    const checkOtherConsigneeName1 = (fieldName, value) => {
        const pincodeRegex = /^[0-9]+$/;
        const cityRegex = /^[a-zA-Z\s]+$/;

        if (fieldName === "other_destination_city") {
            setValidCity1(cityRegex.test(value));
        } 
       
    };
    const handleVehicleCapacityChange = (e) => {
        const value = e.target.value;
        setFormData(prev => ({ ...prev, other_vehicle_capacity: value }));
        validateVehicleCapacity(value);  // Validate in real-time on change
    };
    // const handlePincodeChange = (e) => {
    //     const value = e.target.value;
      
    //     // Allow only numbers and max 6 digits
    //     const isValid = /^[0-9]{0,6}$/.test(value);
    //     if (isValid) {
    //       setFormData(prev => ({
    //         ...prev,
    //         destination_pincode: value
    //       }));
    //       setPincodeErrInBasic(false); 
    //     }
    //   };
    //   const handleValidPincode = (e) => {
    //     const value = e.target.value;
      
    //     // Allow only numbers and max 6 digits
    //     const isValid = /^[0-9]{6}$/.test(value);
    //     setPincodeErrInBasic(!isValid);
    //   };
    const handlePincodeChange = (e) => {
        const value = e.target.value;
         setPincodeTouched(true);
        // Allow only numbers, max 6 digits
        if (/^[0-9]{0,6}$/.test(value)) {
            setFormData(prev => ({
                ...prev,
                destination_pincode: value
            }));
        }
    };
    const validateVehicleCapacity = () => {
        const regex = /^[0-9]+$/;
        setValidVehicleCapacity(regex.test(formData.other_vehicle_capacity))

    }
    const onClickHideAll = () => {
        setSourceValidation(false)
        // setManualInTransitStatusUpdate.dispatch_time("")
        // document.getElementById("File").value = "";
        setInvoiceValid(false)
        setValidTruckNo(true);
        setInvoiceValidForInvoiceLevel(false);

        setOverlay("show-n")
        setLoadShow("show-n")
        setManualTripUploadDetails([])
        setFormData({
            driver_mobile_no: '',
            source: '',
            other_source: '',
            other_source_pincode: '',
            truck_no: '',
            truck_seal_no: '',
            entity: '',
            vehicle_type: { label: '', value: '' },
            courier_partner: { label: '', value: '' },
            eway_bill_expiry_date: '',
            invoice_date: '',
            total_weight: '',
            total_cbm: '',
            vehicle_capacity: '',
            consignee_name: '',
            movement_type: '',
            lr_no: '',
            invoice_no: [],
            invoice_no_str: "",
            consigner_name: "",
            consignee_name1: "",
            number_of_boxes: '',
            invoice_category:"",
            destination_pincode: '',
            destination_city: '',
            show: false,
            basicType: '',
            basicTitle: '',
            // loadshow: 'show-n',
            // overly: 'show-n',
            dispatch_time: new Date(),
            fuel_type: { label: '', value: '' },
            consignee_code: "",
            other_vehicle_capacity: "",
            other_destination_pincode: "",
            other_destination_city: "",
        })
        setOtherConsignments([])


        setSourceList1(originalSourceList)
        // navigate('/consignments/active_consignments')

    }
    const saveConsignmentData = async (event) => {
        event.preventDefault();
        // setOverlay("show-m")
        // if(pincodeErrInBasic || validPincode || (validPincodeForCons.length> 0 && validPincodeForCons) || (pincodeErrInConsignment.length>0 && pincodeErrInConsignment)){
        if (
            pincodeErrInBasic ||
            validPincode ||
            validPincodeForCons.some(err => err === true) ||
            pincodeErrInConsignment.some(err => err === true)
        ) {
            setShow(true);
            setTitle("Please enter the valid pincode"); // Display the error message from the backend
            setType("danger");
            return;
        }

        let specialCharcters = 0;
        // console.log(formData, "formdata888");
        
        const { driver_mobile_no, source, truck_no, entity, truck_seal_no, vehicle_type, vehicle_capacity, courier_partner, eway_bill_expiry_date, consignee_name, movement_type, lr_no, invoice_no, number_of_boxes, destination_pincode, destination_city, other_source, other_source_pincode, total_cbm, total_weight, invoice_date, consignee_code, consigner_name, consignee_name1, dispatch_time,invoice_category,
            other_transporter,
            other_vehicle_type,
            other_consignee_name,
            other_vehicle_capacity,
            other_destination_pincode, other_destination_city, fuel_type, input_consignee_code, delivery_date_time } = formData;
        // let entityValues1 = selectedEntity.map(entity=> entity.value)
        let add_consignment_params = {}
        if (specialCharcters === 0) {
            let fieldsChk = 0;
            const isGeneralFieldsFilled = entity.value !== '' && dispatch_time && !invoiceValid && !invoiceValidForInvoiceLevel && source.value !== '' && truck_no !== '' &&
                vehicle_type.value !== '' && fuel_type.value !== '' && courier_partner.value !== '' && movement_type.value !== '' && delivery_date_time &&
                invoice_no.length > 0 && invoice_date && invoice_category !== ""; 

            // console.log(dispatch_time, driver_mobile_no, !invoiceValid, source.value, truck_no, entity.value, vehicle_type.value,
            //     fuel_type.value, courier_partner.value, movement_type.value, invoice_no, invoice_date, total_weight, "allll fields8");

            // console.log(isGeneralFieldsFilled, "isGeneralFieldsFilled");


            // Check if consignee-related mandatory fields are filled based on the consignee selection
            // const isConsigneeFilled = (consignee_name.value !== 'Others' && destination_city !== "" && destination_pincode !== "")
            //     || (consignee_name.value === 'Others' && other_consignee_name !== "" && other_destination_city !== "" && other_destination_pincode !== "");
            const isConsigneeFilled =
                movement_type.value === "Customer Delivery"

                    ? (
                        // Customer Delivery
                        (consignee_name1.value !== "Others" &&
                            destination_city !== "" &&
                            destination_pincode !== "") ||

                        (consignee_name1.value === "Others" &&
                            other_consignee_name !== "" &&
                            other_destination_city !== "" &&
                            other_destination_pincode !== "")
                    )

                    : (
                        // Other movement types
                        (consignee_name.value !== "Others" &&
                            destination_city !== "" &&
                            destination_pincode !== "") ||

                        (consignee_name.value === "Others" &&
                            other_consignee_name !== "" &&
                            other_destination_city !== "" &&
                            other_destination_pincode !== "")
                    );

            // console.log(isConsigneeFilled, "isConsigneeFilled");

            const otherSource = (source.value === "Others" && other_source !== "" && other_source_pincode !== "") || (source.value !== "Others" && true);
            // console.log(otherSource, "otherSource");

            const vehicleTypeValidation = (vehicle_type.value === "Others" && other_vehicle_capacity !== "" && other_vehicle_type !== "") || (vehicle_type.value !== "Others" && true)
            // console.log(vehicleTypeValidation, "vehicleTypeValidation");

            // var consigneeValidation = true;

            // if (movement_type.value === "Customer Delivery") {
            //     if (!consignee_name1) {
            //         consigneeValidation = false;
            //     } else {
            //         consigneeValidation = true;
            //     }
            // } else {
            //     consigneeValidation = true;
            // }
            let consigneeValidation = true;

            if (movement_type.value === "Customer Delivery") {

                if (consignee_name1?.value === "Others") {
                    // When "Others" is selected
                    consigneeValidation =
                        other_consignee_name !== "" &&
                        other_destination_city !== "" &&
                        other_destination_pincode !== "";
                }
                else {
                    // Normal consignee selected
                    consigneeValidation =
                        consignee_name1?.value !== "" &&
                        destination_city !== "" &&
                        destination_pincode !== "";
                }
            }
            if (!invoice_category) {
                setShow(true);
                setTitle("Please select Invoice Type");
                setType("danger");
                return;
            }
            // console.log("consigneeValidationm", consigneeValidation);

            if (isGeneralFieldsFilled && isConsigneeFilled && consigneeValidation && vehicleTypeValidation && otherSource) {
                // console.log("trueeeeee");

                fieldsChk = 1;
            }
            // console.log(fieldsChk, "fieldsChk");

            // if(other_source){
            //     fieldsChk = 1;
            // }
            var invoice_date1 = new Date(invoice_date);
            var dispatch_time1 = new Date(dispatch_time);

            let missingFields=[]

            if(otherConsignments.length>0){
                otherConsignments.forEach((consignment, index)=>{
                    if (!consignment.invoice_no || consignment.invoice_no.length === 0) {
                        missingFields.push("Invoice No");
                      }
                      if (!consignment.invoice_date) {
                        missingFields.push("Invoice Date");
                      }
                      if (!consignment.lr_no || consignment.lr_no.trim() === "") {
                        missingFields.push("LR No");
                      }
                      if (!consignment.entity || consignment.entity.value === "") {
                        missingFields.push("Entity");
                      } 
                      
                      if(movement_type.value === "Customer Delivery" && consignment.consignee_name1.value!=="Others"  && (consignment.consignee_name1.value==="" || consignment.destination_pincode==="" || consignment.destination_city ==="") ){
                        
                        missingFields.push("Consignee Name1")
                      }
                      if(movement_type.value === "Customer Delivery" && consignment.consignee_name1.value==="Others" && ( consignment.other_consignee_name ==="" || consignment.other_destination_pincode==="" || consignment.other_destination_city ==="") ){
                        
                        missingFields.push("Other Consignee Name1")
                      }
                      if((movement_type.value !== "Customer Delivery" && consignment.consignee_name.value=="Others" && ( consignment.other_consignee_name===""  || consignment.other_destination_pincode==="" || consignment.other_destination_city ==="")) ){

                        missingFields.push("Other Consignee Name")
                      }
                      if((movement_type.value !== "Customer Delivery" && consignment.consignee_name.value!=="Others" && ( consignment.consignee_name.value===""  || consignment.destination_pincode==="" || consignment.destination_city ==="")) ){

                        missingFields.push("Consignee Name")
                      }               
                })
            }

            if (fieldsChk === 1 && missingFields.length===0) {
                if (dispatch_time1 > invoice_date1) {
                    if(!invoiceValid && !invoiceValidForInvoiceLevel){

                        add_consignment_params = {
                            driver_mobile_no,
                            source: source.label ? source.label : "",
                            truck_no,
                            truck_seal_no,
                            // entity: entityValues1.length>0 ? entityValues1 : [], 
                            entity: entity.value ? entity.value : "",
                            vehicle_type: vehicle_type.value,
                            courier_partner: courier_partner.value.toUpperCase(),
                            eway_bill_expiry_date: eway_bill_expiry_date ? formatDateForSubmission1(eway_bill_expiry_date) : "",
                            invoice_date: invoice_date ? formatDateForSubmission(invoice_date) : "",
                            dispatch_date: dispatch_time ? formatDateForSubmission1(dispatch_time) : "",
                            total_weight: total_weight,
                            total_cbm: total_cbm,
    
                            vehicle_capacity: vehicle_capacity.value,
                            movement_type: movement_type.value,
                            lr_no,
                            // invoice_no: `${invoice_no}`, 
                            invoice_no: invoice_no,
                            no_of_boxes: number_of_boxes,
                            invoice_category:invoice_category,
                            consigner_name: consigner_name,
                            fuel_type: fuel_type.value,
                        };
    
    
                        if (movement_type.value === "Customer Delivery" && formData.consignee_name1.value !== "Others") {
    
                            add_consignment_params.consignee_name = formData.consignee_name1.value
                            add_consignment_params.destination_pincode = formData.destination_pincode;
                            add_consignment_params.destination_city = formData.destination_city;
                            add_consignment_params.consignee_code = formData.consignee_code.value
                        }
                        if (movement_type.value === "Customer Delivery" && formData.consignee_name1.value === "Others") {
    
                            add_consignment_params.consignee_name = formData.other_consignee_name
                            add_consignment_params.destination_pincode = formData.other_destination_pincode;
                            add_consignment_params.destination_city = formData.other_destination_city;
                            add_consignment_params.consignee_code = formData.input_consignee_code
                        }
    
                        if (consignee_name.value === "Others") {
                            add_consignment_params.consignee_name = formData.other_consignee_name
                            add_consignment_params.destination_pincode = formData.other_destination_pincode
                            add_consignment_params.destination_city = formData.other_destination_city
                            add_consignment_params.consignee_code = formData.input_consignee_code
                        }
                        if (consignee_name.value !== "Others" && consignee_name1.value === "") {
                            add_consignment_params.consignee_name = formData.consignee_name.label;
                            add_consignment_params.destination_pincode = formData.destination_pincode;
                            add_consignment_params.destination_city = formData.destination_city;
                            add_consignment_params.consignee_code = formData.input_consignee_code
                        }
                        if (add_consignment_params.vehicle_type === "Others") {
                            add_consignment_params.vehicle_type = formData.other_vehicle_type
                        }
                        if (add_consignment_params.vehicle_capacity === "Others") {
                            add_consignment_params.vehicle_capacity = formData.other_vehicle_capacity
                        }
                        if (add_consignment_params.courier_partner === "Others") {
                            add_consignment_params.courier_partner = formData.other_transporter.toUpperCase()
                        }
                        if (other_source) {
                            if (validOtherSource) {
                                add_consignment_params.source = other_source;
                                add_consignment_params.source_pincode = other_source_pincode;
                            }
                        }
    
                        if (otherConsignments.length >= 1) {
                            add_consignment_params.add_dealer = 1
                        }

                        if(isTripsDelivered && isTripsDelivered == 1){
                            add_consignment_params.is_trips_delivered = 1
                            add_consignment_params.delivery_datetime = delivery_date_time ? formatDateForSubmission1(delivery_date_time) : ""
                        }
    
                        // const manualDropPoints = otherConsignments.map((point) => ({
                        //     lr_no: point.lr_no,
                        //     invoice_no: point.invoice_no,
                        //     invoice_date: point.invoice_date ? formatDateForSubmission(point.invoice_date) : "",
                        //     entity:  point.entity.value ? point.entity.value : "",
                        //     consignee_name: movement_type.value === "Customer Delivery" && point.consignee_name1.value !=="Others"
                        //       ? point.consignee_name1.value : (movement_type.value === "Customer Delivery" && point.consignee_name1.value ==="Others") ? point.other_consignee_name
                        //       : point.consignee_name?.value === "Others"
                        //         ? point.other_consignee_name
                        //         : point.consignee_name?.value !== "Others" && point.consignee_name1 === ""
                        //           ? point.consignee_name?.label
                        //           : "",
                        //     destination_pincode :movement_type.value === "Customer Delivery" && point.consignee_name1.value !=="Others"
                        //             ? point.destination_pincode :(movement_type.value === "Customer Delivery" && point.consignee_name1.value ==="Others") ? point.other_destination_pincode
                        //             : point.consignee_name?.value === "Others"
                        //               ? point.other_destination_pincode
                        //               : point.consignee_name?.value !== "Others" && point.consignee_name1 === ""
                        //                 ? point.destination_pincode
                        //                 : "",
                                
                        //     destination_city: movement_type.value === "Customer Delivery" && point.consignee_name1.value !=="Others"
                        //     ? point.destination_city :(movement_type.value === "Customer Delivery" && point.consignee_name1.value ==="Others") ? point.other_destination_city
                        //     : point.consignee_name?.value === "Others"
                        //       ? point.other_destination_city
                        //       : point.consignee_name?.value !== "Others" && point.consignee_name1 === ""
                        //         ? point.destination_city
                        //         : "",
                        //     number_of_boxes: point.number_of_boxes,
                        //     invoice_category:point.invoice_category,
                        //     total_weight: point.total_weight,
                        //     total_cbm: point.total_cbm,
                        //     consignee_code: movement_type.value === "Customer Delivery" && point.consignee_name1.value !=="Others"
                        //     ? point.consignee_code.value :(movement_type.value === "Customer Delivery" && point.consignee_name1.value ==="Others") ? point.input_consignee_code
                        //     : point.consignee_name?.value === "Others"
                        //       ? point.input_consignee_code
                        //       : point.consignee_name?.value !== "Others" && point.consignee_name1 === ""
                        //         ? point.input_consignee_code
                        //         : "" 
                        // }));
                        const manualDropPoints = otherConsignments.map((point) => ({
                            lr_no: point.lr_no,
                            invoice_no: point.invoice_no,
                            invoice_date: point.invoice_date
                                ? formatDateForSubmission(point.invoice_date)
                                : "",

                            entity: point.entity.value
                                ? point.entity.value
                                : "",

                            consignee_name:
                                movement_type.value === "Customer Delivery" &&
                                    point.consignee_name1.value !== "Others"
                                    ? point.consignee_name1.value
                                    : movement_type.value === "Customer Delivery" &&
                                        point.consignee_name1.value === "Others"
                                        ? point.other_consignee_name
                                        : point.consignee_name?.value === "Others"
                                            ? point.other_consignee_name
                                            : point.consignee_name?.value !== "Others" &&
                                                point.consignee_name1.value === ""
                                                ? point.consignee_name?.label
                                                : "",

                            destination_pincode:
                                movement_type.value === "Customer Delivery" &&
                                    point.consignee_name1.value !== "Others"
                                    ? point.destination_pincode
                                    : movement_type.value === "Customer Delivery" &&
                                        point.consignee_name1.value === "Others"
                                        ? point.other_destination_pincode
                                        : point.consignee_name?.value === "Others"
                                            ? point.other_destination_pincode
                                            : point.consignee_name?.value !== "Others" &&
                                                point.consignee_name1.value === ""
                                                ? point.destination_pincode
                                                : "",

                            destination_city:
                                movement_type.value === "Customer Delivery" &&
                                    point.consignee_name1.value !== "Others"
                                    ? point.destination_city
                                    : movement_type.value === "Customer Delivery" &&
                                        point.consignee_name1.value === "Others"
                                        ? point.other_destination_city
                                        : point.consignee_name?.value === "Others"
                                            ? point.other_destination_city
                                            : point.consignee_name?.value !== "Others" &&
                                                point.consignee_name1.value === ""
                                                ? point.destination_city
                                                : "",

                            number_of_boxes: point.number_of_boxes,
                            invoice_category: point.invoice_category,
                            total_weight: point.total_weight,
                            total_cbm: point.total_cbm,
                            consignee_code:
                                movement_type.value === "Customer Delivery" &&
                                    point.consignee_name1.value !== "Others"
                                    ? point.consignee_code.value
                                    : movement_type.value === "Customer Delivery" &&
                                        point.consignee_name1.value === "Others"
                                        ? point.input_consignee_code
                                        : point.consignee_name?.value === "Others"
                                            ? point.input_consignee_code
                                            : point.consignee_name?.value !== "Others" &&
                                                point.consignee_name1.value === ""
                                                ? point.input_consignee_code
                                                : ""
                        }));
                        // console.log(
                        //     manualDropPoints,
                        //     "STEP-1 FRONTEND manualDropPoints"
                        // );
                        const combinedParams = {
                            add_consignment_params,            // First set of params for updating the collection
                            manualTripUploadDetails: manualDropPoints,
                            email: decode(localStorageEmail),  // Second set of params to be sent to the backend API
                            source_from: "web" 
                        };
                        try {
                            const response = await redirectURL.post('/consignments/saveConsignmentData', combinedParams);
    
                            //     // Check if the response is successful
                            if (response.data.status.toLowerCase() === 'success') {
                                //       // Clear form data
                                setFormData({
                                    ...formData,
                                    driver_mobile_no: '',
                                    source: { label: "", value: "" },
                                    truck_no: '',
                                    truck_seal_no: '',
                                    entity: '',
                                    vehicle_type: { label: '', value: '' },
                                    courier_partner: { label: '', value: '' },
                                    eway_bill_expiry_date: '',
                                    invoice_date: '',
                                    total_weight: '',
                                    total_cbm: '',
                                    vehicle_capacity: '',
                                    consignee_name: { label: "", value: "" },
                                    movement_type: { label: "", value: "" },
                                    lr_no: '',
                                    invoice_no: [],
                                    invoice_no_str: "",
                                    consigner_name: "",
                                    consignee_name1: "",
                                    consignee_code: "",
                                    number_of_boxes: '',
                                    invoice_category: "",
                                    destination_pincode: '',
                                    destination_city: '',
                                    dispatch_time: new Date(),
                                    fuel_type: { label: '', value: '' },
                                    input_consignee_code:""
                                });
                                setOtherConsignments([])
                                setMobileNumber("");
    
                                //       // Clear manual trip upload details
                                setManualTripUploadDetails([]);
                                // setShow(true);
                                setTitle(response.data.message);
                                
                                setType('success');
                                setLoadShow('show-n');
                                setOverlay('show-m');
                                setInvoiceValid(false)
                                setInvoiceValidForInvoiceLevel(false)
                                setValidTruckNo('')
                                setSaveConfirmationSlide("slide95")
                                //   setTimeout(() => {
                                //     setOverlay('show-n'); // This ensures only the slider closes
                                // }, 2000);
                                //     //   window.location.reload();
                            } else if (response.data.status.toLowerCase() === 'failure') {
                                //       // Show error message returned from backend
                                setShow(true);
                                setTitle(response.data.message); // Display the error message from the backend
                                setType("danger");
                            } else {
                                setShow(true);
                                setTitle(response.data.message === 'Consignment Code Already Exists' ?
                                    'Consignment Code Already Exists' : 'Failed to create consignment');
                                setType('danger');
                                setFormData({
                                    ...formData,
                                    driver_mobile_no: '',
                                    source: '',
                                    truck_no: '',
                                    truck_seal_no: '',
                                    entity: '',
                                    vehicle_type: { label: '', value: '' },
                                    courier_partner: { label: '', value: '' },
                                    eway_bill_expiry_date: '',
                                    invoice_date: '',
                                    total_weight: '',
                                    total_cbm: '',
                                    vehicle_capacity: '',
                                    consignee_name: '',
                                    movement_type: '',
                                    lr_no: '',
                                    invoice_no: [],
                                    invoice_no_str: "",
                                    consigner_name: "",
                                    consignee_name1: "",
                                    consignee_code: "",
                                    number_of_boxes: '',
                                    invoice_category:"",
                                    destination_pincode: '',
                                    destination_city: '',
                                    dispatch_time: new Date(),
                                    fuel_type: { label: '', value: '' },
                                    input_consignee_code:""
                                });
                                setManualTripUploadDetails([]);
                                setOtherConsignments([])
                                setMobileNumber("");
    
                            }
                        } catch (error) {
                            //     // Handle any network or unexpected errors
    
                            setShow(true);
                            setTitle("An unexpected error occurred. Please try again.");
                            setType("danger");
                        }
                    }else{
                        setShow(true)
                        setTitle("Please enter the valid invoice no's")
                        setType("danger")
                        setLoadShow('show-n')
                    }


                } else {
                    setShow(true)
                    setTitle("Dispatch Date should be greater than invoice date")
                    setType("danger")
                    setLoadShow('show-n')
                    // setOverlay('show-n')

                }
            } else {
                setShow(true)
                setTitle('Please fill mandatory fields')
                setType('danger')
                missingFields=[]
            }
        }
        else {
            setShow(true)
            setTitle('Special characters are not allowed')
            setType('danger')

        }

    };
    // const handleSaveNAdd = () => {
    //     // setShowCard(false)
    //     const totalConsignments = 1 + otherConsignments.length;

    //     if (totalConsignments >= 5) {
    //         setShow(true);
    //         setTitle("You can add a maximum of 5 consignments only.");
    //         setType("danger");
    //         return;
    //     }
    //     setConsignmentCount(prev => prev + 1)
    //     setOtherConsignments((prev) => [
    //         ...prev,
    //         {
    //             lr_no: "",
    //             invoice_no: "",
    //             invoice_no_str: "",
    //             invoice_date: "",
    //             entity: {label:"", value:""},
    //             consignee_name: {label:"", value:""},
    //             consignee_name1: "",
    //             destination_pincode: '',
    //             destination_city: '',
    //             other_destination_pincode: "",
    //             other_destination_city: "",
    //             number_of_boxes: '',
    //             invoice_category: "",
    //             total_weight: '',
    //             total_cbm: '',
    //             input_consignee_code:''
    //         },
    //     ]);

    // }
    const handleSaveNAdd = () => {
        const totalConsignments = 1 + otherConsignments.length;

        if (totalConsignments >= 5) {
            setShow(true);
            setTitle("You can add a maximum of 5 consignments only.");
            setType("danger");
            return;
        }
        setConsignmentCount(prev => prev + 1);
        setOtherConsignments((prev) => [
            ...prev,
            {
                lr_no: "",
                invoice_no: [],
                invoice_no_str: "",
                invoice_date: "",
                entity: { label: "", value: "" },
                consignee_name: { label: "", value: "" },
                consignee_name1: { label: "", value: "" },
                consignee_code: { label: "", value: "" },
                destination_pincode: "",
                destination_city: "",
                other_consignee_name: "",
                other_destination_pincode: "",
                other_destination_city: "",
                number_of_boxes: "",
                invoice_category: "",
                total_weight: "",
                total_cbm: "",
                input_consignee_code: ""
            }
        ]);
    };
    const handleOtherConsignmentChange = (e, index) => {
        const { name, value } = e.target;

        // const alphanumericRegex = /^[a-zA-Z0-9]*$/;
        const alphanumericRegex = /^[^\s]*$/

        if (name === 'lr_no') {
            /* PMS ID - 10259 */
            if (!alphanumericRegex.test(value)) {
                return; // prevent updating state if value is not alphanumeric
              } 

            // +1 because index 0 is `formData`
            // if (isDuplicateLR(value, index + 1)) {
            //   alert('LR No must be unique across all consignments');
            //   return;
            // }
          }

        setOtherConsignments((prev) => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [name]: value,
            };
            return updated;
        });
        if (name === "other_destination_city" || name === "other_destination_pincode") {
            checkOtherConsigneeName1(name, value);
        }
    };
    const handleValidPincodeFrCons = (e, index) => {
        const value = e.target.value;
      
        // Allow only numbers and max 6 digits
        const isValid = /^[0-9]{6}$/.test(value);
        setPincodeErrInConsignment(prevErrors => {
            const updatedErrors = [...prevErrors];
            updatedErrors[index] = !isValid;
            return updatedErrors;
          });
     
    };
    const handleValidOthrPincodeFrCons = (e, index) => {
        const value = e.target.value;
      
        // Allow only numbers and max 6 digits
        const isValid = /^[0-9]{6}$/.test(value);
        setValidPincodeForCons(prevErrors => {
            const updatedErrors = [...prevErrors];
            updatedErrors[index] = !isValid;
            return updatedErrors;
          });
     
    };
    const handleOtherWeightChange = (e, index) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setOtherConsignments((prev) => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    total_weight: value,
                };
                return updated;
            });
        }
    };
    const handleOtherCBMChange = (e, index) => {
        const value = e.target.value;

        if (/^\d*\.?\d*$/.test(value)) {
            setOtherConsignments((prev) => {
                const updated = [...prev];
                updated[index] = {
                    ...updated[index],
                    total_cbm: value,
                };
                return updated;
            });
        }
       
    };
    const handleDispatchDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        
            setFormData((prev) => ({
                ...prev,
                dispatch_time: date,
            }));
            
    };

    const handleDeliveryDate = (date) => {
        if (!date) return;
        setFormData((prev) => ({
            ...prev,
            delivery_date_time: date,
        }));
    };


    const handleInvoiceDate = (date) => {
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        const dispatchDate = new Date(formData.dispatch_time);
        if (date > dispatchDate) {
            alert("Invoice date cannot be after Dispatch date.");
            return;
          }
        
            setFormData((prev) => ({
                ...prev,
                invoice_date: date
            }));
            
    };
    const handleOtherConsignmentInvoiceDate = (date, index) => {
        
        if (!date) return; // Ensure a valid date is passed
        // Save the raw Date object for DatePicker
        const dispatchDate = new Date(formData.dispatch_time);
        if (date > dispatchDate) {
            alert("Invoice date cannot be after Dispatch date.");
            return;
          }

        const updated = [...otherConsignments];
  updated[index] = {
    ...updated[index],
    invoice_date: date,
  };

  setOtherConsignments(updated);
            
    };
    var hideAll = () => {
        setOverlay("show-n");
      
    }
    const onConfirm = () => {
        setShow(false);

        // setLoader(false)
        // if (reloadPage.current) {
        //   
        //   window.location.reload()
        // }
        
            if (type === 'success'){
                // onClose();
                navigate('/consignments/active_consignments')
            }
        
       

    };
    const handleAddMoreConsignment =()=>{
        setSaveConfirmationSlide("")
        window.location.reload()
    }

    return (
        <>
         <SweetAlert
                                show={show}
                                title={<span style={{ fontSize: "1rem" }}>{title}</span>}
                                onConfirm={onConfirm}
                                confirmBtnBsStyle={type}
                                confirmBtnCssClass="sweetButton"
                                customClass='sweetWidth'
                                type={type}>
                            </SweetAlert>
            <div className='row'>
                <div className='col-sm-12'>
                    <h5 className='title-heading mb-10p' style={{ fontWeight: "bold", marginTop: "-20px" }}>
                        Add Consignments
                    </h5>

                     {/* Handling offline trips using tabs instead of a toggle button */}
                    
                    {/* <button
                        className={`float-right toggle-button ${isTripsDelivered === 1 ? "active" : ""}`}
                        onClick={handleToggle}
                        title="Offline Trip"
                        style={{ marginTop: "-30px", marginRight: isTripsDelivered === 1 ? "160px" : "80px" }}
                    >
                        <i className="icofont icofont-toggle-off off" aria-hidden="true"></i>
                        <i className="icofont icofont-toggle-on on" aria-hidden="true"></i>
                    </button>
                    {isTripsDelivered === 1 && (
                        <span  className="float-right"  style={{ marginTop: "-25px", marginRight: "80px", backgroundColor: "#e0f7fa", color: "#00796b",fontSize: "14px", fontWeight: 500 }}>
                            Offline Trip
                        </span>
                    )} */}

                    <div className='float-right'>
                        <button className="back-button" style={{ marginTop: "-30px" }} onClick={handleBack}> Back</button>
                    </div>

                </div>
            </div>

            <div>
                <button
                    onClick={() => handleTabChange("onTrip")}
                    className={tabName === "onTrip" ? "btn btn-h pgtab" : "btn pgtab"}
                    style={{
                        borderTopLeftRadius: "6px",
                        display: tabName === "onTrip" ? "inline-flex" : "",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                    }}
                >
                    Create Trip
                </button>

                <button
                    onClick={() => handleTabChange("offTrip")}
                    className={tabName === "offTrip" ? "btn btn-h pgtab" : "btn pgtab"}
                    style={{
                        display: tabName === "offTrip" ? "inline-flex" : "",
                        boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)"
                    }}
                >
                    Create Offline trip
                </button>
            </div>

            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    
                    <div className="c mt-3">
                        
                        {Array.from({ length: consignmentCount }).map((_, index) => (
                            <div key={index} className="mb-3">
                                <div className="cons-creation-card-title-header" style={{ borderRadius: "8px 8px 0px 0px" }}>
                                    <div className="cons-creation-head" >
                                        {/* Left side content */}
                                        <h4 style={{ fontWeight: "600", fontSize: "14px" }}>

                                           {index===0 ? "Basic Details" : `Consignment ${index}`}
                                        </h4>

                                        <div className='float-right'>
                                        {[0,1].includes(index) ? "" : (<i className="icofont icofont-ui-delete consignment-del"  onClick={() => handleDelConsignment(index-1)}></i>)  }

                                        {index === 0 ? "" : (
  <i
    className={`icofont ${showCards[index] ? "icofont-rounded-down" : "icofont-rounded-right"} down-arrow`}
    onClick={() => handleArrow(index)}
    style={{ cursor: "pointer" }}
  ></i>
)}

                                        </div>

                                    </div>
                                </div>
                                { showCards[index] &&
                                    <div className='card'>
                                        <div className="row card-body">

                                            {index === 0 ?
                                             <>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Truck No<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleTruckNoChange}
                                                        value={formData.truck_no}
                                                        name="truck_no"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validateTruckNo === false && (
                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "0px" }}>
                                                            Enter Valid Truck Number
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">
                                                        Dispatch Date<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <div id="addConsignment-datepicker">
                                                        <DatePicker
                                                            selected={formData.dispatch_time}
                                                            onChange={(date) => handleDispatchDate(date)} 
                                                            className="datepicker-custom-ptl5 form-control"
                                                            showTimeSelect
                                                            maxDate={new Date()}
                                                            timeFormat="HH:mm"
                                                            timeIntervals={15} // Adjust this if you want different time intervals
                                                            timeCaption="Time"
                                                            dateFormat="dd-MM-yyyy HH:mm" // Adjusted format to match the original format
                                                            // placeholderText="Date" // Equivalent to placeholder in the original
                                                            id="dispatch_date"
                                                            autoComplete='off'
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        // style={{width:"100%"}}
                                                        />
                                                    </div>

                                                </div>
                                                
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">Transporter<span style={{ color: 'red' }}>*</span> </label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.courier_partner}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                courier_partner: { label: e.label, value: e.value }
                                                            }));
                                                            var tptName1 = e.label.toLowerCase();
                                                            fetchingMaxFuelType(tptName1)
                                                            var validFuelType = tptNFuel.filter(tpt => (tpt.label.toLowerCase() === tptName1)).map(e => e.value).flat()
                                                            var validFuelTypes = validFuelType.map(e => ({ label: e, value: e }))
                                                            setFuelTypeList(validFuelTypes)

                                                            // Enable Other Transporter field when "Other" is selected
                                                            // if (e.value === "Others") {
                                                            //     setEnableCourierType(true);
                                                            // } else {
                                                            //     setFormData((prev) => ({ ...prev, other_transporter: "" }));
                                                            //     setEnableCourierType(false);
                                                            // }
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={courierPartnerList}
                                                    />

                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Movement Type<span style={{ color: 'red' }}>*</span>  </label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.movement_type}
                                                        onChange={(e) => {
                                                            // Update formData and enableEdit state together
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                movement_type: { label: e.label, value: e.value },
                                                            }));
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                consignee_name: { label: "", value: "" },
                                                                consignee_name1: { label: "", value: "" },
                                                                destination_city:"",
                                                                destination_pincode:""
                                                            }));
                                                            setOtherConsignments((prev) =>
                                                                prev.map(item => ({
                                                                    ...item,
                                                                    consignee_name: { label: "", value: "" },
                                                                    consignee_name1: { label: "", value: "" },
                                                                    destination_city: "",
                                                                    destination_pincode: ""
                                                                }))
                                                            );

                                                            // Update enableEdit state based on the selected value
                                                            if (e.value === "Customer Delivery") {
                                                                setEnableEdit(true);
                                                            } else {
                                                                setEnableEdit(false);
                                                            }
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={movementType}
                                                    />
                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">Source<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.source}
                                                        isDisabled={sourceValidation}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                source: { label: e.label, value: e.value },
                                                                  invoice_no: [],
                                                                    invoice_no_str: ""
                                                            }));
                                                            setOtherConsignments(prev =>
                                                                prev.map(item => ({
                                                                  ...item,
                                                                  invoice_no: [],
                                                                  invoice_no_str: ""
                                                                }))
                                                              );
                                                            if (e.value === "Others") {
                                                                setEnableSourceField(true);
                                                            } else {
                                                                setFormData((prev) => ({ ...prev, other_source: "" }));
                                                                setEnableSourceField(false);
                                                            }
                                                            // fetchingSourceSeries(e.value)
                                                            // else {
                                                            //     setErrorMssge("Please fill in the invoice_no field first");
                                                            // }
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"
                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={formData.movement_type.value === "Supplier Movement" ? supplierMovementSourceList : sourceList}
                                                    />
                                                    {sourceValidation && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                        Please enter valid Invoice Numbers. The source will be auto-filled accordingly.                                            </span>}
                                                </div>
                                                {enableSourceField && <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Other Source<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleInputChange}
                                                        value={formData.other_source}
                                                        name="other_source"
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {validOtherSource === false && (
                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "16px" }}>
                                                            Enter Valid Source Name
                                                        </span>
                                                    )}
                                                </div>}
                                                {enableSourceField && (
                                                    <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                        <label className="form-label">
                                                            Others Source Pincode<span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <input
                                                            type="text"
                                                            className="form-input"
                                                            onChange={handleInputChange}
                                                            value={formData.other_source_pincode}
                                                            name="other_source_pincode"
                                                            autoComplete="off"
                                                            required
                                                        />
                                                        {/* Optionally display error message */}
                                                        {!/^[0-9]{6}$/.test(formData.other_source_pincode) && formData.other_source_pincode !== '' && (
                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "16px" }}>
                                                    Pincode must be 6 digits.
                                                </span>
                                            )}
                                                    </div>
                                                )}
                                                    <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignor Name</label>
                                                    {formData.movement_type.value === "Supplier Movement" ? (
                                                        <CreatableSelect
                                                            closeMenuOnSelect={true}
                                                            isClearable
                                                            placeholder="Select or type a Consignor Name"
                                                            value={formData.consigner_name ? { label: formData.consigner_name, value: formData.consigner_name } : null}
                                                            onChange={(e) => {
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    consigner_name: e ? e.value : "",
                                                                }));
                                                            }}
                                                            style={{ borderRadius: "0px" }}
                                                            styles={{
                                                                control: (provided, state) => ({
                                                                    ...provided,
                                                                    fontSize: "0.8rem",
                                                                    color: "#6e707e",
                                                                    width: "100%"
                                                                }),
                                                                singleValue: (provided, state) => ({
                                                                    ...provided,
                                                                    fontSize: "0.9rem",
                                                                }),
                                                            }}
                                                            options={supplierList}
                                                        />
                                                    ) : (
                                                        <input
                                                            type="text"
                                                            className="form-input"
                                                            onChange={handleInputChange}
                                                            value={formData.consigner_name}
                                                            name="consigner_name"
                                                            autoComplete='off'
                                                        />
                                                    )}
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">
                                                        Vehicle Type<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.vehicle_type}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                vehicle_type: { label: e.label, value: e.value }
                                                            }));
                                                            if (e.value === "Others") {
                                                                setEnableVehicelType(true);
                                                                setFormData((prev) => ({ ...prev, other_vehicle_type: "", other_vehicle_capacity: '' }));

                                                            } else {
                                                                setEnableVehicelType(false);
                                                                fetchVehicleDetails(e.label, e.value)

                                                            }
                                                        }}
                                                        style={{ borderRadius: "0px", maxWidth: "415px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={vehicleFtlTypeList} />
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Truck Seal No
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleInputChange}
                                                        value={formData.truck_seal_no}
                                                        name="truck_seal_no"
                                                        autoComplete='off'
                                                    />

                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">E-Way Bill Expiry Date</label>
                                                    <div id="addConsignment-datepicker">
                                                        <DatePicker
                                                            selected={formData.eway_bill_expiry_date}
                                                            onChange={handleEwayDate}
                                                            name="eway_bill_expiry_date"
                                                            className="datepicker-custom-ptl5 form-control"
                                                            showTimeSelect
                                                            timeFormat="HH:mm:ss"
                                                            timeIntervals={15} // Adjust this if you want different time intervals
                                                            timeCaption="Time"
                                                            dateFormat="dd-MM-yyyy HH:mm:ss" // Adjusted format to match the original format
                                                            minDate={new Date()} // Prevents past date selection
                                                            id="eway_bill_expiry_date"
                                                            autoComplete="off"
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Fuel Type<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.fuel_type}
                                                        onChange={(e) => setFormData((prev) => ({
                                                            ...prev,
                                                            fuel_type: { label: e.label, value: e.value }
                                                        }))}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"
                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={fuelTypeList}
                                                        required
                                                    />
                                                </div>

                                           


                                               
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Driver Mobile No.{SIMTrackingTpts.includes(formData.courier_partner?.label?.toLowerCase()) && <span style={{ color: 'red' }}>*</span> }</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        maxLength="10"
                                                        value={mobileNumber}
                                                        onChange={handlePhoneInputChange}
                                                        name="driver_mobile_no"
                                                        autoComplete='off'
                                                        required={SIMTrackingTpts.includes(formData.courier_partner?.label?.toLowerCase())}
                                                    />
                                                </div>
                                               

                                              
                                              
                                              
                                            
                                               
                                               
                                               




                                                {!enableVehicleType && <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">
                                                        Vehicle Capacity<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        // onChange={(e)=> setFormData(prev => ({...prev, destination_pincode:e.target.value }))}
                                                        value={formData.vehicle_capacity}
                                                        name="vehicle_capacity"
                                                        autoComplete='off'
                                                        // onFocus={checkConsignee}
                                                        disabled={true}

                                                    />
                                                </div>}
                                                    {tabName === "offTrip" && (
                                                        <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                            <label className="form-label">
                                                                Delivery Date<span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <div id="addConsignment-datepicker">
                                                                <DatePicker
                                                                    selected={formData.delivery_date_time || null}
                                                                    onChange={handleDeliveryDate}
                                                                    className="datepicker-custom-ptl5 form-control"
                                                                    showTimeSelect
                                                                    timeFormat="HH:mm"
                                                                    timeIntervals={15}
                                                                    timeCaption="Time"
                                                                    dateFormat="dd-MM-yyyy HH:mm"
                                                                    autoComplete="off"
                                                                    onKeyDown={(e) => e.preventDefault()}
                                                                    minDate={formData.dispatch_time ? new Date(formData.dispatch_time) : null}
                                                                    maxDate={new Date()} // Prevents future date
                                                                    minTime={
                                                                        formData.delivery_date_time && formData.dispatch_time &&
                                                                            new Date(formData.delivery_date_time).toDateString() === new Date(formData.dispatch_time).toDateString()
                                                                            ? new Date(formData.dispatch_time)
                                                                            : new Date(new Date().setHours(0, 0, 0, 0))  // << fix here
                                                                    }
                                                                    maxTime={
                                                                        formData.delivery_date_time &&
                                                                            new Date(formData.delivery_date_time).toDateString() === new Date().toDateString()
                                                                            ? new Date()
                                                                            : new Date(new Date(formData.delivery_date_time).setHours(23, 59, 59, 999))
                                                                    }

                                                                />


                                                            </div>
                                                        </div>
                                                    )}

                                                    {enableVehicleType && (
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">
                                                                Other Vehicle Type<span style={{ color: 'red' }}>*</span>
                                                            </label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) =>
                                                                    setFormData((prev) => ({
                                                                        ...prev,
                                                                        other_vehicle_type: e.target.value
                                                                    }))
                                                                }
                                                                value={formData.other_vehicle_type}
                                                                name="other_vehicle_type"
                                                                autoComplete="off"
                                                                required
                                                            />
                                                        </div>
                                                    )}

                                                {enableVehicleType && <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Other Vehicle Capacity<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleVehicleCapacityChange}
                                                        value={formData.other_vehicle_capacity}
                                                        name="other_vehicle_capacity"
                                                        autoComplete='off'
                                                        required
                                                    />
                                                    {validVehicleCapacity === false && (
                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "5px", marginLeft: "16px" }}>
                                                            Enter Valid Vehicle Capacity
                                                        </span>
                                                    )}
                                                </div>}
                                               
                                             
                                               


                                            </> :  (index ===1 ? <>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">LR No<span style={{ color: 'red' }}>*</span> </label>
                                                    <input type="text"
                                                        value={formData.lr_no}
                                                        name="lr_no"
                                                        className='form-input'
                                                        onChange={handleInputChange}
                                                        onBlur={(e)=>handleLRNoBlur("truckLevel",e,index+1)}

                                                        autoComplete='off'
                                                        required />

                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Invoice No<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => handleInvoiceChange(e, "truckLevel")}
                                                        onBlur={() => {
                                                            const isValid = validateInput(formData.invoice_no, "truckLevel");

                                                            setIsValid(isValid);
                                                            if (!isValid) {
                                                                
                                                                setSourceValidation(true)
                                                                setErrorMsg1(true)
                                                                setInvoiceValid(true)
                                                                console.error("Validation failed for invoice input.");
                                                            } else {
                                                                setSourceValidation(false)
                                                                setInvoiceValid(false)
                                                            }
                                                        }}
                                                        value={formData.invoice_no_str}
                                                        name="invoice_no"
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {invoiceValid && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                        Enter the Valid Invoice No's
                                                    </span>}
                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">Invoice Date<span style={{ color: 'red' }}>*</span></label>
                                                    <div id="addConsignment-datepicker">
                                                        <DatePicker
                                                            selected={formData.invoice_date}
                                                            onChange={(date)=>handleInvoiceDate(date)}
                                                            name="invoice_date"
                                                            className="datepicker-custom-ptl5 form-control"
                                                            showTimeSelect={false}
                                                            // timeFormat="HH:mm:ss"
                                                            // timeIntervals={15} // Adjust this if you want different time intervals
                                                            // timeCaption="Time"
                                                            dateFormat="dd-MM-yyyy" // Adjusted format to match the original format
                                                            maxDate={new Date()}
                                                            id="invoice_date"
                                                            autoComplete="off"
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Entity<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        // closeMenuOnSelect={false}
                                                        // isMulti={true}
                                                        // value={selectedEntity}
                                                        closeMenuOnSelect={true}
                                                        value={formData.entity}
                                                        onChange={(e)=> setFormData((prev)=>({
                                                            ...prev, 
                                                            entity:{label:e.label, value: e.value}
                                                        }))}
                                                        // onChange ={e=> setSelectedEntity(e)}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"
                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={entityList}
                                                    />
                                                </div>
                                              
                                                {formData.movement_type.value === "Customer Delivery" && (<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                    {/* <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleInputChange}
                                                        value={formData.consignee_name1}
                                                        name="consignee_name1"
                                                        autoComplete='off'
                                                        required
                                                    /> */}
                                                     <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.consignee_name1}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                consignee_name1: { label: e.label, value: e.value }
                                                            }));
                                                            // Check if the selected option is "Other"
                                                            if (e.label !== "Others") {
                                                                fetchConsigneeDetails(e.value, e.label, "truckLevel");
                                                            } else {
                                                                setFormData(prev => ({ ...prev, consignee_code: {label:"", value:""} }));
                                                            }

                                                         
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consigneeNameNCodes}
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>)}

                                                {formData.movement_type.value !== "Customer Delivery" && (<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.consignee_name}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                consignee_name: { label: e.label, value: e.value }
                                                            }));
                                                            // Check if the selected option is "Other"
                                                            if (e.label !== "Others") {
                                                                fetchConsignerDetails(e.value, e.label, "truckLevel");
                                                            } else {
                                                                setFormData(prev => ({ ...prev, destination_pincode: "", destination_city: "" }));
                                                            }

                                                            // Validate after updating the selection
                                                            validateOption("consigneeName");
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consignees}
                                                    />
                                                                                                    </div>)}
                                                                                                    {(formData.consignee_name1.value !== "Others" && formData.movement_type.value ==="Customer Delivery") &&<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Code</label>
                                                  
                                                      <Select
                                                        closeMenuOnSelect={true}
                                                        value={formData.consignee_code}
                                                        onChange={(e) => {
                                                            setFormData((prev) => ({
                                                                ...prev,
                                                                consignee_code: { label: e.label, value: e.value }
                                                            }));
                                                            // Check if the selected option is "Other"
                                                            if (e.label !== "Others") {
                                                                fetchConsigneeCodeDetails(e.value, e.label, "truckLevel");
                                                            } else {
                                                                setFormData(prev => ({ ...prev, consignee_name1: {label:"", value:""} }));
                                                            }

                                                         
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consigneeCodesList}
                                                    />
                                                </div>}
                                               
                                                {(formData.movement_type.value!=="Customer Delivery" || (formData.movement_type.value ==="Customer Delivery" && formData.consignee_name1.value==="Others")) && <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">{formData.consignee_name1.value === 'Others' ? 'Other Consignee Code' : 'Consignee Code'}</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={handleInputChange}
                                                        value={formData.input_consignee_code}
                                                        name="input_consignee_code"
                                                        autoComplete='off'
                                                    />
                                                    </div>}

                                                    {(formData.consignee_name.value === "Others" || formData.consignee_name1.value ==="Others") && 
                                                        (<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => {
                                                                    const { value } = e.target;
                                                                    setFormData(prev => ({ ...prev, other_consignee_name: value }));
                                                                    // validateOtherConsignee(value);
                                                                }}
                                                                value={formData.other_consignee_name}
                                                                name="other_consignee_name"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                        </div>)
                                                        } 

                                                       {(formData.consignee_name.value === "Others" || formData.consignee_name1.value ==="Others" ) && 
                                                       <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => {
                                                                    const { value } = e.target

                                                                    setFormData(prev => ({ ...prev, other_destination_city: value }));
                                                                    checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                                }}
                                                                value={formData.other_destination_city}
                                                                name="other_destination_city"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {validCity === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}
                                                        </div>
                                                        } 
                                                        {(formData.consignee_name.value === "Others" || formData.consignee_name1.value ==="Others") &&
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => {
                                                                    const { value } = e.target
                                                                    setFormData(prev => ({ ...prev, other_destination_pincode: value }));
                                                                    checkOtherConsigneeName(e.target.name, value); // Call validation here
                                                                }}
                                                                value={formData.other_destination_pincode}
                                                                name="other_destination_pincode"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {validPincode === true && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Pincode must be exactly 6 digits</span>}
                                                        </div>
                                                        } 
                                                           {(formData.consignee_name.value !== "Others" && formData.consignee_name1.value !=="Others")&&
                                                    <>
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Destination City<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={handleInputChange}
                                                                value={capitalizeWords(formData.destination_city)}
                                                                name="destination_city"
                                                                autoComplete='off'
                                                                // onFocus={checkConsignee}
                                                                disabled={!enableEdit}
                                                                required={enableEdit}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={handlePincodeChange}
                                                                // onBlur={handleValidPincode}
                                                                value={formData.destination_pincode}
                                                                name="destination_pincode"
                                                                autoComplete='off'
                                                                // onFocus={checkConsignee}
                                                                disabled={!enableEdit}
                                                                required={enableEdit}
                                                            />
                                                            {pincodeErrInBasic && (
                                                                <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Pincode must be exactly 6 digits
                                                            </span>
                                                            )}
                                                        </div>
                                                        
                                               

                                                    </>
                                                }
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Total Weight</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Allow only numeric values (including empty string for clearing the input)
                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                setFormData((prev) => ({ ...prev, total_weight: value }));
                                                            }
                                                        }}
                                                        value={formData.total_weight}
                                                        name="total_weight"
                                                        autoComplete="off"
                                                    />
                                                    {!/^\d*\.?\d+$/.test(formData.total_weight) && formData.total_weight !== '' && (
                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                            Total Weight must be a numeric value.
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Total CBM</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => {
                                                            const value = e.target.value;
                                                            // Allow only numeric values (including empty string for clearing the input)
                                                            if (/^\d*\.?\d*$/.test(value)) {
                                                                setFormData((prev) => ({ ...prev, total_cbm: value }));
                                                            }
                                                        }}
                                                        value={formData.total_cbm}
                                                        name="total_cbm"
                                                        autoComplete="off"
                                                    />
                                                    {!/^\d*\.?\d+$/.test(formData.total_cbm) && formData.total_cbm !== '' && (
                                                        <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                            Total CBM must be a numeric value.
                                                        </span>
                                                    )}
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Number of Boxes</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) =>
                                                            setFormData((prev) => ({ ...prev, number_of_boxes: e.target.value }))
                                                        }
                                                        onInput={(e) => {
                                                            // Remove non-numeric characters
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                        }}
                                                        value={formData.number_of_boxes}
                                                        name="number_of_boxes"
                                                        autoComplete="off"
                                                    />
                                                    </div>
                                                    {/* <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                        <label className="form-label">
                                                            Invoice Type<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select
                                                            isLoading={loadingInvoiceTypes}
                                                            closeMenuOnSelect={true}
                                                            value={formData.invoice_category?.value ? formData.invoice_category : null}
                                                            onChange={(selected) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    invoice_category: selected,
                                                                }))
                                                            }
                                                            options={invoiceTypeList}
                                                            placeholder="Select Invoice Type"
                                                        />

                                                    </div> */}
                                                    <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                        <label className="form-label">
                                                            Invoice Type<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                        <Select
                                                            isLoading={loadingInvoiceTypes}
                                                            closeMenuOnSelect={true}
                                                            value={
                                                                invoiceTypeList.find(
                                                                    (option) => option.value === formData.invoice_category
                                                                ) || null
                                                            }
                                                            onChange={(selected) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    invoice_category: selected?.value || "",
                                                                }))
                                                            }
                                                            options={invoiceTypeList}
                                                            placeholder="Select Invoice Type"
                                                            styles={{
                                                                control: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: "0.8rem",
                                                                    color: "#6e707e",
                                                                    width: "100%",
                                                                }),
                                                                singleValue: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: "0.9rem",
                                                                }),
                                                                option: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: "0.8rem",
                                                                }),
                                                            }}
                                                        />
                                                    </div>

                                                </> : <>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">LR No<span style={{ color: 'red' }}>*</span> </label>
                                                    <input type="text"
                                                        value={otherConsignments[index - 2]?.lr_no || ""}
                                                        name="lr_no"
                                                        className='form-input'
                                                        onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                        onBlur={(e)=>handleLRNoBlur("lr_no",e,index-2)}
                                                        autoComplete='off'
                                                        required />

                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">
                                                        Invoice No<span style={{ color: 'red' }}>*</span>
                                                    </label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => handleInvoiceChange(e, "invoiceLevel", index - 2)}
                                                        onBlur={(e) => {
                                                            const currentConsignment = otherConsignments[index - 2];
                                                            const isValid = validateInputForInvoice(currentConsignment?.invoice_no || [], "invoiceLevel", index-2, e);

                                                            if (!isValid) {
                                                                setInvoiceValidForInvoiceLevel(true)
                                                                console.error("Validation failed for invoice input.");
                                                            } else {
                                                                setInvoiceValidForInvoiceLevel(false)
                                                            }
                                                        }}
                                                        value={otherConsignments[index - 2]?.invoice_no_str || ""}
                                                        name="invoice_no"
                                                        autoComplete="off"
                                                        required
                                                    />
                                                    {invoiceValidForInvoiceLevel && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                        Enter the Valid Invoice No's
                                                    </span>}
                                                </div>
                                                <div className="form-group col-xl-3 col-lg-3 d-flex flex-column">
                                                    <label className="form-label">Invoice Date<span style={{ color: 'red' }}>*</span></label>
                                                    <div id="addConsignment-datepicker">
                                                        <DatePicker
                                                            selected={otherConsignments[index - 2]?.invoice_date || ""}
                                                            onChange={(date) => handleOtherConsignmentInvoiceDate(date, index - 2)}

                                                            name="invoice_date"
                                                            className="datepicker-custom-ptl5 form-control"
                                                            showTimeSelect={false}
                                                            // timeFormat="HH:mm:ss"
                                                            // timeIntervals={15} // Adjust this if you want different time intervals
                                                            // timeCaption="Time"
                                                            dateFormat="dd-MM-yyyy" // Adjusted format to match the original format
                                                            maxDate={new Date()}
                                                            id="invoice_date"
                                                            autoComplete="off"
                                                            onKeyDown={(e) => e.preventDefault()}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Entity<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        // closeMenuOnSelect={false}
                                                        // isMulti={true}
                                                        // value={selectedEntity}
                                                        name="entity"
                                                        closeMenuOnSelect={true}
                                                        value={otherConsignments[index - 2]?.entity || {label:"", value:""}}
                                                        onChange={(selectedOption) => {
                                                            const { value, label } = selectedOption;
                                                            const updated = [...otherConsignments];
                                                            updated[index - 2]["entity"] = { label: label, value: value };
                                                            setOtherConsignments(updated);
                                                        }}
                                                        // onChange ={e=> setSelectedEntity(e)}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"
                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={entityList}
                                                    />
                                                </div>
                                              
                                                {formData.movement_type.value === "Customer Delivery" && (<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                
                                                     <Select
                                                        closeMenuOnSelect={true}
                                                        value={otherConsignments[index - 2]?.consignee_name1 || {label:"",value:""}}
                                                        
                                                        onChange={(selectedOption) => {
                                                            const { value, label } = selectedOption;
                                                            const updated = [...otherConsignments];
                                                            updated[index - 2]["consignee_name1"] = { label: label, value: value };
                                                            setOtherConsignments(updated);
                                                            // Check if the selected option is "Other"
                                                            if (label !== "Others") {
                                                                fetchConsigneeDetails(value, label, "invoiceLevel", index - 2);
                                                            } else {
                                                                setOtherConsignments((prev) => {
                                                                    const updated = [...prev];
                                                                    updated[index - 2] = {
                                                                        ...updated[index - 2],
                                                                        consignee_code: {label:"", value:""}
                                                                    };
                                                                    return updated;
                                                                });
                                                            }

                                                            // Validate after updating the selection
                                                            validateOption1("consigneeName1", index - 2);
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consigneeNameNCodes}
                                                    />
                                                    {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                </div>)}
                                               
                                             

                                                {formData.movement_type.value !== "Customer Delivery" && (<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                    <Select
                                                        closeMenuOnSelect={true}
                                                        value={otherConsignments[index - 2]?.consignee_name || {label:"",value:""}}
                                                        onChange={(selectedOption) => {
                                                            const { value, label } = selectedOption;
                                                            const updated = [...otherConsignments];
                                                            updated[index - 2]["consignee_name"] = { label: label, value: value };
                                                            setOtherConsignments(updated);
                                                            // Check if the selected option is "Other"
                                                            if (label !== "Others") {
                                                                fetchConsignerDetails(value, label, "invoiceLevel", index - 2);
                                                            } else {
                                                                setOtherConsignments((prev) => {
                                                                    const updated = [...prev];
                                                                    updated[index - 2] = {
                                                                        ...updated[index - 2],
                                                                        destination_pincode: "",
                                                                        destination_city: ""
                                                                    };
                                                                    return updated;
                                                                });
                                                            }

                                                            // Validate after updating the selection
                                                            validateOption1("consigneeName", index - 2);
                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consignees}
                                                    />
                                                    
                                                </div>
                                                )}
                                                  {(otherConsignments[index - 2]?.consignee_name1.value !== "Others" && formData.movement_type.value ==="Customer Delivery") &&<div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Consignee Code</label>
                                                  
                                                      <Select
                                                        closeMenuOnSelect={true}
                                                        value={otherConsignments[index - 2]?.consignee_code}
                                                       
                                                        onChange={(selectedOption) => {
                                                            const { value, label } = selectedOption;
                                                            const updated = [...otherConsignments];
                                                            updated[index - 2]["consignee_code"] = { label: label, value: value };
                                                            setOtherConsignments(updated);
                                                            // Check if the selected option is "Other"
                                                            if (label !== "Others") {
                                                                fetchConsigneeCodeDetails(value, label, "invoiceLevel", index - 2);
                                                            } else {
                                                                setOtherConsignments((prev) => {
                                                                    const updated = [...prev];
                                                                    updated[index - 2] = {
                                                                        ...updated[index - 2],
                                                                        consignee_name1: {label:"", value:""}
                                                                    };
                                                                    return updated;
                                                                });
                                                            }

                                                        }}
                                                        style={{ borderRadius: "0px" }}
                                                        styles={{
                                                            control: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.8rem",
                                                                color: "#6e707e",
                                                                width: "100%"

                                                            }),
                                                            singleValue: (provided, state) => ({
                                                                ...provided,
                                                                fontSize: "0.9rem",
                                                            }),
                                                        }}
                                                        options={consigneeCodesList}
                                                    />
                                                </div>}
                                               
                                                {(formData.movement_type.value!=="Customer Delivery" || (formData.movement_type.value ==="Customer Delivery" && otherConsignments[index - 2]?.consignee_name1.value==="Others")) && <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">{otherConsignments[index - 2]?.consignee_name1.value === 'Others' ? 'Other Consignee Code' : 'Consignee Code'}</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                        value={otherConsignments[index - 2]?.input_consignee_code || ""}
                                                        name="input_consignee_code"
                                                        autoComplete='off'
                                                    />
                                                    </div>}

                                                    {(otherConsignments[index - 2]?.consignee_name.value === "Others" || otherConsignments[index - 2]?.consignee_name1.value === "Others") && 
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Consignee Name<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                                value={otherConsignments[index - 2]?.other_consignee_name || ""}
                                                                name="other_consignee_name"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {/* {validOtherConsigneeName === false && <span style={{color:"red", fontSize:"12px", marginTop:"5px"}}>Enter Valid Consignee Name</span>} */}
                                                        </div>}

                                                        {(otherConsignments[index - 2]?.consignee_name.value === "Others" || otherConsignments[index - 2]?.consignee_name1.value === "Others") && 


                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Destination City<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                                value={otherConsignments[index - 2]?.other_destination_city || ""}
                                                                name="other_destination_city"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {validCity1 === false && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Enter Valid City Name</span>}
                                                        </div>}
                                                        {(otherConsignments[index - 2]?.consignee_name.value === "Others" || otherConsignments[index - 2]?.consignee_name1.value === "Others") && 

                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Other Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                                onBlur={(e)=> handleValidOthrPincodeFrCons(e, index-2)}

                                                                value={otherConsignments[index - 2]?.other_destination_pincode || ""}

                                                                name="other_destination_pincode"
                                                                autoComplete='off'
                                                                required
                                                            />
                                                            {validPincodeForCons[index-2] && <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>Pincode must be exactly 6 digits</span>}
                                                        </div>
}

                                               
                                                {(otherConsignments[index - 2]?.consignee_name.value !== "Others" && otherConsignments[index - 2]?.consignee_name1.value !== "Others")  &&
                                                    <>
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Destination City<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                                value={otherConsignments[index - 2]?.destination_city || ""}
                                                                name="destination_city"
                                                                autoComplete='off'
                                                                // onFocus={checkConsignee}
                                                                disabled={!enableEdit}
                                                                required={enableEdit}
                                                            />
                                                        </div>
                                                        <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                            <label className="form-label">Destination Pincode<span style={{ color: 'red' }}>*</span></label>
                                                            <input
                                                                type="text"
                                                                className="form-input"
                                                                onChange={(e) => handleOtherConsignmentChange(e, index - 2)}
                                                                value={otherConsignments[index - 2]?.destination_pincode || ""}
                                                                onBlur={(e)=> handleValidPincodeFrCons(e, index-2)}
                                                                name="destination_pincode"
                                                                autoComplete='off'
                                                                // onFocus={checkConsignee}
                                                                disabled={!enableEdit}
                                                                required={enableEdit}
                                                            />
                                                           {pincodeErrInConsignment[index - 2] && (
                                                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Pincode must be exactly 6 digits
                                                            </span>
                                                            )}
                                                        </div>

                                                    </>
                                                }

                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Total Weight</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        name="total_weight"
                                                        value={otherConsignments[index - 2]?.total_weight || ""}
                                                        onChange={(e) => handleOtherWeightChange(e, index - 2)}
                                                        autoComplete="off"
                                                    />
                                                    {!/^\d*\.?\d+$/.test(otherConsignments[index - 2]?.total_weight) &&
                                                        !!otherConsignments[index - 2]?.total_weight && (
                                                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Total Weight must be a numeric value.
                                                            </span>
                                                        )}
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Total CBM</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        name="total_cbm"
                                                        value={otherConsignments[index - 2]?.total_cbm || ""}
                                                        onChange={(e) => handleOtherCBMChange(e, index - 2)}
                                                        autoComplete="off"
                                                    />
                                                    {!/^\d*\.?\d+$/.test(otherConsignments[index - 2]?.total_cbm) &&
                                                        !!otherConsignments[index - 2]?.total_cbm && (
                                                            <span style={{ color: "red", fontSize: "12px", marginTop: "5px" }}>
                                                                Total CBM must be a numeric value.
                                                            </span>
                                                        )}
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                    <label className="form-label">Number of Boxes</label>
                                                    <input
                                                        type="text"
                                                        className="form-input"
                                                        onChange={(e) => handleOtherConsignmentChange(e, index - 2)}

                                                        onInput={(e) => {
                                                            // Remove non-numeric characters
                                                            e.target.value = e.target.value.replace(/[^0-9]/g, '');
                                                        }}
                                                        value={otherConsignments[index - 2]?.number_of_boxes || ""}
                                                        name="number_of_boxes"
                                                        autoComplete="off"
                                                    />
                                                </div>
                                                <div className="col-xl-3 col-lg-3 form-group d-flex flex-column">
                                                        <label className="form-label">
                                                            Invoice Type<span style={{ color: "red" }}>*</span>
                                                        </label>
                                                            <Select
                                                                isLoading={loadingInvoiceTypes}
                                                                closeMenuOnSelect={true}
                                                                value={
                                                                    invoiceTypeList.find(
                                                                        (option) =>
                                                                            option.value === otherConsignments[index - 2]?.invoice_category
                                                                    ) || null
                                                                }
                                                                onChange={(selected) => {
                                                                    setOtherConsignments((prev) => {
                                                                        const updated = [...prev];   
                                                                        updated[index - 2] = {
                                                                            ...updated[index - 2], 
                                                                            invoice_category: selected?.value || "",
                                                                        };

                                                                        return updated;
                                                                    });
                                                                }}
                                                                options={invoiceTypeList}
                                                                placeholder="Select Invoice Type"
                                                                styles={{
                                                                    control: (provided) => ({
                                                                        ...provided,
                                                                    fontSize: "0.8rem",
                                                                    color: "#6e707e",
                                                                    width: "100%",
                                                                }),
                                                                singleValue: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: "0.9rem",
                                                                }),
                                                                option: (provided) => ({
                                                                    ...provided,
                                                                    fontSize: "0.8rem",
                                                                }),
                                                            }}
                                                        />

                                                    </div>
                                            </>)}

                                        </div>
                                    </div>}
                            </div>))}
                    </div>
                </div>
            </div>

            <div className='d-flex flex-row float-right mb-50p mt-20p'>
                <button className='cancel-button' onClick={onClickHideAll}>Cancel</button>
                <button className="save-add-new-button ml-20p" onClick={handleSaveNAdd}>Save & Add New</button>
                <button class="save-consignment-button ml-20p" onClick={saveConsignmentData}>Save Consignment</button>

            </div>
            {saveConfirmationSlide
                 && 
                 <div className={"sliderBlockForConsCreation " + (saveConfirmationSlide)} >
                      <div className="d-flex justify-content-center mt-20p">
      <img src={SuccessTick} alt="Success" className="success-icon" />
    </div>
               
                <div className='d-flex mt-10p' style={{marginLeft:"10px"}}>
                            <div className='d-flex flex-column'>
                                <h1 className='confirm-heading'>{title}</h1>
                            </div>
                </div>                
                <div className='d-flex flex-column align-items-center mt-20p'>
                <button className="save-add-new-button" onClick={handleAddMoreConsignment}>Add More Consignment</button>
                <p className="proceed-text" onClick={handleBack}>Proceed</p>                </div>

                </div>} 
            <div className={"overlay-part " + (overlay)} onClick={hideAll}></div>

            <div className={"dataLoadpage " +(loadshow)}>
                </div>
                <div className={"dataLoadpageimg " +(loadshow)}>
                    <div class="loader-box"><div class="loader-box"><div class="rotate dashed colored"></div></div></div>
                </div>
        </>
    )
}

export default addConsignment;
const formatDateForSubmission = (date) => {
    // Check if the input is a valid Date object
    if (!(date instanceof Date)) {
        // Try to convert it to a Date object if possible
        date = new Date(date);
    }

    // If the date is still invalid, handle the error
    if (isNaN(date.getTime())) {
        throw new Error("Invalid date format");
    }

const pad = (num) => num.toString().padStart(2, '0');
return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()}`;
};
const formatDateForSubmission1 = (date) => {
// Check if the input is a valid Date object
if (!(date instanceof Date)) {
    // Try to convert it to a Date object if possible
    date = new Date(date);
}

// If the date is still invalid, handle the error
if (isNaN(date.getTime())) {
    throw new Error("Invalid date format");
}

const pad = (num) => num.toString().padStart(2, '0');
return `${pad(date.getDate())}-${pad(date.getMonth() + 1)}-${date.getFullYear()} ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
const capitalizeWords = (str) => {
    if (typeof str !== "string") {
        console.warn("Invalid input to capitalizeWords:", str); // Log invalid inputs for debugging
        return ""; // Return an empty string for non-string inputs
    }
    return str
        .toLowerCase()
        .replace(/\b\w/g, char => char?.toUpperCase());
};  